import { OrderBillTo, TaxId } from './generated-types-new';

/**
 * @deprecated
 */
export type Maybe<T> = T | null | undefined;

/**
 * @deprecated
 */
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values
 * @deprecated
 */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
};

/**
 * @deprecated
 */
export type AdditionalNotes = {
  __typename?: 'AdditionalNotes';
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

/**
 * Add-ons are child entitlements to parent entitlements.
 * @deprecated
 * Examples: Team Members for Statuspage
 */
export type AddOn = {
  __typename?: 'AddOn';
  offeringId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Int']>;
  dateAdded?: Maybe<Scalars['String']>;
  dateRemoved?: Maybe<Scalars['String']>;
  dateLastBilled?: Maybe<Scalars['String']>;
  nextBillDate?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<BillingStatus>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type AddOnConnection = Connection & {
  __typename?: 'AddOnConnection';
  totalCount?: Maybe<Scalars['Int']>;
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<AddOnEdge>>>;
  nodes?: Maybe<Array<Maybe<AddOn>>>;
};

/**
 * @deprecated
 */
export type AddOnEdge = Edge & {
  __typename?: 'AddOnEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<AddOn>;
};

/**
 * @deprecated
 */
export type Adjustments = {
  __typename?: 'Adjustments';
  reason?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
};

/**
 * @deprecated
 */
export type AggregatedProduct = {
  __typename?: 'AggregatedProduct';
  productName?: Maybe<Scalars['String']>;
  userCount?: Maybe<Scalars['Int']>;
  billedProductCount?: Maybe<Scalars['Int']>;
  freeProductCount?: Maybe<Scalars['Int']>;
  unlimitedUserProductCount?: Maybe<Scalars['Int']>;
  evaluationProductCount?: Maybe<Scalars['Int']>;
};

/**
 * @deprecated
 */
export type Announcement = {
  __typename?: 'Announcement';
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  previewThumbnail?: Maybe<PreviewThumbnail>;
  expiryDate?: Maybe<Scalars['String']>;
  meta?: Maybe<AnnouncementMeta>;
  isUnseen?: Maybe<Scalars['Boolean']>;
};

/**
 * @deprecated
 */
export type AnnouncementConnection = Connection & {
  __typename?: 'AnnouncementConnection';
  totalCount?: Maybe<Scalars['Int']>;
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<AnnouncementEdge>>>;
  nodes?: Maybe<Array<Maybe<Announcement>>>;
};

/**
 * @deprecated
 */
export type AnnouncementEdge = Edge & {
  __typename?: 'AnnouncementEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<Announcement>;
};

/**
 * @deprecated
 */
export type AnnouncementMeta = {
  __typename?: 'AnnouncementMeta';
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/**
 * Properties that drive the CASSI application experience (non-entity related)
 * @deprecated
 */
export type Application = {
  __typename?: 'Application';
  /** Application slug that will identify the application */
  id?: Maybe<Scalars['String']>;
  /** Custom icon url that will be displayed in the header */
  iconUrl?: Maybe<Scalars['String']>;
  /** Application name that will be displayed in navigation */
  name?: Maybe<Scalars['String']>;
  /** Populates the help menu in the navigation */
  helpNavigation?: Maybe<Array<Maybe<NavigationItem>>>;
  /** Populates the app switcher menu in the navigation */
  appSwitcherNavigation?: Maybe<Array<Maybe<NavigationItem>>>;
  banner?: Maybe<Banner>;
  portalApp?: Maybe<PortalApp>;
  announcements?: Maybe<AnnouncementConnection>;
  featureFlag?: Maybe<FeatureFlag>;
};

/**
 * Properties that drive the CASSI application experience (non-entity related)
 * @deprecated
 */
export type ApplicationPortalAppArgs = {
  id: Scalars['String'];
};

/**
 * Properties that drive the CASSI application experience (non-entity related)
 * @deprecated
 */
export type ApplicationFeatureFlagArgs = {
  flagKey: Scalars['String'];
  targetingProperties?: Maybe<Scalars['JSON']>;
};

/**
 * @deprecated
 */
export type AtlassianAccess = {
  __typename?: 'AtlassianAccess';
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<BillingStatus>;
};

/**
 * @deprecated
 */
export type AuditEdge = {
  __typename?: 'AuditEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AuditNote>;
};

/**
 * A record of a single update made to an entity, such as updating a payment
 * method or changing a site name.
 * @deprecated
 */
export type AuditNote = {
  __typename?: 'AuditNote';
  /** User or system who triggered the update */
  author?: Maybe<Scalars['String']>;
  /** Description of the update */
  body?: Maybe<Scalars['String']>;
  /** Date the update happened */
  created?: Maybe<Scalars['String']>;
  /**Contact email address */
  contactKey?: Maybe<Scalars['String']>;
  /* AuditNote metadata */
  metadata?: Maybe<Array<Maybe<AuditNoteMetadata>>>;
};

/**
 * @deprecated
 */
export type AuditNoteMetadata = {
  __typename?: 'AuditNoteMetadata';
  fieldName?: Maybe<Scalars['String']>;
  fieldValue?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type AuditNoteConnection = Connection & {
  __typename?: 'AuditNoteConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  nodes: Array<Maybe<AuditNote>>;
  edges: Array<Maybe<AuditEdge>>;
};

/**
 * @deprecated
 */
export type AuditNoteResult = {
  __typename?: 'AuditNoteResult';
  totalHits?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<AuditNote>>>;
};

/**
 * @deprecated
 */
export type CommerceNoteSearchParams = {
  __typename?: 'CommerceNoteSearchParams';
  id?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  contactKey?: Maybe<Scalars['String']>;
  entitlementKey?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  refundKey?: Maybe<Scalars['String']>;
  serial?: Maybe<Scalars['String']>;
  transactionAccountNumber?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type FetchAuditNotesForEntityQueryVariables = Exact<{
  searchParams?: Maybe<CommerceNoteSearchParams>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchAuditNotesForEntityQuery = { __typename?: 'Query' } & {
  auditNotes: { __typename?: 'AuditNoteConnection' } & Pick<AuditNoteConnection, 'totalCount'> & {
      nodes: Array<
        Maybe<
          { __typename?: 'AuditNote' } & Pick<AuditNote, 'body' | 'author' | 'created' | 'contactKey'> & {
              metadata?: Maybe<
                Array<Maybe<{ __typename?: 'AuditNoteMetadata' } & Pick<AuditNoteMetadata, 'fieldName' | 'fieldValue'>>>
              >;
            }
        >
      >;
      pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
    };
};

/**
 * Application banner to share information such as an announcement, warning, or outage with users
 * @deprecated
 */
export type Banner = {
  __typename?: 'Banner';
  title: Scalars['String'];
  enabled: Scalars['Boolean'];
  bannerAppearance: Scalars['String'];
  message?: Maybe<Scalars['JSON']>;
  incidentTicketUrl?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  dismissalExpiration?: Maybe<Scalars['Int']>;
};

/**
 * @deprecated
 */
export type BenefitsValueObj = {
  __typename?: 'BenefitsValueObj';
  appliedOn?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

/**
 * @deprecated
 */
export type Benefit = {
  __typename?: 'Benefit';
  benefitType?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
  values?: Maybe<Array<Maybe<BenefitsValueObj>>>;
  scale?: Maybe<Scalars['String']>;
  iterations?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  subBenefitType?: Maybe<Scalars['String']>;
  customisable?: Maybe<BenefitCustomisableObj>;
};

/**
 * @deprecated
 */
export type BenefitCustomisableObj = {
  __typename?: 'BenefitCustomisableObj';
  value?: Maybe<BenefitCustomisableValue>;
  duration?: Maybe<Array<Maybe<Scalars['String']>>>;
  iterations?: Maybe<BenefitCustomisableValue>;
};

/**
 * @deprecated
 */
export type BenefitCustomisableValue = {
  __typename?: 'BenefitCustomisableValue';
  type?: Maybe<Scalars['String']>;
  lowerBound?: Maybe<Scalars['Int']>;
  upperBound?: Maybe<Scalars['Int']>;
};

/**
 * @deprecated
 */
export enum BenefitType {
  TRIAL = 'TRIAL',
}

/**
 * @deprecated
 */
export type Billing = {
  __typename?: 'Billing';
  billingInformation: BillTo;
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  billingContacts: BillingContacts;
};

/**
 * @deprecated
 */
export type BillingAdmin = {
  __typename?: 'BillingAdmin';
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  relationshipType?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  atlassianAccountId?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type BillingAdminConnection = Connection & {
  __typename?: 'BillingAdminConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<BillingAdminEdge>>>;
  nodes?: Maybe<Array<Maybe<BillingAdmin>>>;
};

/**
 * @deprecated
 */
export type BillingAdminEdge = Edge & {
  __typename?: 'BillingAdminEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: BillingAdmin;
};

/**
 * @deprecated
 */
export type BillingContact = {
  __typename?: 'BillingContact';
  email: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  atlassianAccountId?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type BillingContacts = {
  __typename?: 'BillingContacts';
  totalHits: Scalars['Int'];
  contacts: Array<Maybe<BillingContact>>;
};

/**
 * The countries that can be billed for form validation
 * @deprecated
 */
export type BillingCountry = {
  __typename?: 'BillingCountry';
  isoCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type BillingCountryConnection = Connection & {
  __typename?: 'BillingCountryConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  nodes: Array<Maybe<BillingCountry>>;
  edges: Array<Maybe<BillingCountryEdge>>;
};

/**
 * @deprecated
 */
export type BillingCountryEdge = Edge & {
  __typename?: 'BillingCountryEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: BillingCountry;
};

/**
 * The states or regions that can be billed for form validation
 * @deprecated
 */
export type BillingCountryState = {
  __typename?: 'BillingCountryState';
  isoCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type BillingCountryStateConnection = Connection & {
  __typename?: 'BillingCountryStateConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  nodes: Array<Maybe<BillingCountryState>>;
  edges: Array<Maybe<BillingCountryStateEdge>>;
};

/**
 * @deprecated
 */
export type BillingCountryStateEdge = Edge & {
  __typename?: 'BillingCountryStateEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: BillingCountryState;
};

/**
 * @deprecated
 */
export enum BillingFrequency {
  MONTHLY = 'MONTHLY',
  ANNUAL = 'ANNUAL',
  OTHER = 'OTHER',
}

/**
 * @deprecated
 */
export enum CreditStatus {
  OPEN = 'OPEN',
  VOIDED = 'VOIDED',
  APPLIED = 'APPLIED',
}

/**
 * Status of the entitlement, includes CCP and HAMS statuses
 * @deprecated
 */
export enum BillingStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  SUSPENDED = 'SUSPENDED',
  INACTIVE = 'INACTIVE',
}

/**
 * @deprecated
 */
export type BillTo = {
  __typename?: 'BillTo';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type ChargeQuantity = {
  __typename?: 'ChargeQuantity';
  chargeElement?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};

/**
 * @deprecated
 */
export type CloudProduct = {
  __typename?: 'CloudProduct';
  id?: Maybe<Scalars['ID']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['ID']>;
  billingStatus?: Maybe<BillingStatus>;
  isCloud?: Maybe<Scalars['Boolean']>;
  platform?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type CloudProductConnection = Connection & {
  __typename?: 'CloudProductConnection';
  totalCount?: Maybe<Scalars['Int']>;
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<CloudProductEdge>>>;
  nodes?: Maybe<Array<Maybe<CloudProduct>>>;
};

/**
 * @deprecated
 */
export type CloudProductEdge = Edge & {
  __typename?: 'CloudProductEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<CloudProduct>;
};

/**
 * @deprecated
 */
export type CloudSite = {
  __typename?: 'CloudSite';
  baseProduct?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingGroupId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  bitbucketUserProfileType?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteSen?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  createdDate?: Maybe<Scalars['String']>;
  customerAccountId?: Maybe<Scalars['String']>;
  customerDomain?: Maybe<Scalars['String']>;
  dataSource?: Maybe<EntitlementDataSource>;
  edition?: Maybe<Scalars['String']>;
  entitlementGroupId?: Maybe<Scalars['String']>;
  entitlementPeriods?: Maybe<Array<Maybe<EntitlementPeriod>>>;
  featureVariables?: Maybe<Scalars['JSON']>;
  firstPeriodEndDate?: Maybe<Scalars['String']>;
  firstPeriodStartDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  licenseLevel?: Maybe<Scalars['String']>;
  licensedTo?: Maybe<Scalars['String']>;
  migrationEvaluationId?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  parentSen?: Maybe<Scalars['String']>;
  partnerAccountId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  prioritySupport?: Maybe<Scalars['String']>;
  productCatalogId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  provisioningOverrideId?: Maybe<Scalars['Float']>;
  rangeEndDate?: Maybe<Scalars['JSON']>;
  renewalAction?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['Float']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
  vendorId?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type CloudSiteConnection = Connection & {
  __typename?: 'CloudSiteConnection';
  totalCount?: Maybe<Scalars['Int']>;
  pageInfo?: Maybe<PageInfo>;
  nodes?: Maybe<Array<Maybe<CloudSite>>>;
  edges?: Maybe<Array<Maybe<CloudSiteEdge>>>;
};

/**
 * @deprecated
 */
export type CloudSiteEdge = Edge & {
  __typename?: 'CloudSiteEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<CloudSite>;
};
/**
 * @deprecated
 */
export type CloudSubscription = {
  __typename?: 'CloudSubscription';
  accountId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sen?: Maybe<Scalars['String']>;
  businessKey?: Maybe<Scalars['String']>;
  accountOwnerEmail?: Maybe<Scalars['String']>;
  baseProduct?: Maybe<Scalars['String']>;
  isAddon?: Maybe<Scalars['Boolean']>;
  billingContactEmail?: Maybe<Scalars['String']>;
  billingCycle?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  firstPeriodStartDate?: Maybe<Scalars['String']>;
  firstPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  licenseLevel?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  isCloud?: Maybe<Scalars['Boolean']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  renewalAction?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  planType?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  sourceSystem?: Maybe<Scalars['String']>;
  pageName?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<UserRole>>>;
  childEntitlements?: Maybe<CloudSubscriptionConnection>;
};

/**
 * @deprecated
 */
export type CloudSubscriptionConnection = {
  __typename?: 'CloudSubscriptionConnection';
  totalHits?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<CloudSubscription>>>;
};

/**
 * @deprecated
 */
export type CloudSubscriptionSearchParams = {
  query?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

/**
 * Address details used for billing information.
 * @deprecated
 */
export type CommerceAddress = {
  __typename?: 'CommerceAddress';
  name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  taxIds?: Maybe<Array<Maybe<TaxId>>>;
  phone?: Maybe<Scalars['String']>;
  /** Pricing plan type that orders should be allowed for. ([CCP Reference](https://hello.atlassian.net/wiki/spaces/tintin/pages/927987612/Elements+of+CCP+Architecture)) */
  shipToPriceEligibility?: Maybe<Scalars['String']>;
  taxExempt?: Maybe<Scalars['Boolean']>;
  hasLinkedSubscriptions?: Maybe<Scalars['Boolean']>;
};

/**
 * @deprecated
 */
export type CommerceAddressConnection = Connection & {
  __typename?: 'CommerceAddressConnection';
  totalCount?: Maybe<Scalars['Int']>;
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<CommerceAddressEdge>>>;
  nodes?: Maybe<Array<Maybe<CommerceAddress>>>;
};

/**
 * @deprecated
 */
export type CommerceAddressEdge = Edge & {
  __typename?: 'CommerceAddressEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: CommerceAddress;
};

/**
 * The connection model provides a standard mechanism for slicing and paginating the result set.
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm)
 * @deprecated
 */
export type Connection = {
  totalCount?: Maybe<Scalars['Int']>;
  pageInfo?: Maybe<PageInfo>;
};

/**
 * Common parameters when searching for a connection and paginating (either by
 * cursor or offset). Uses Hydra terminology by default.
 * @deprecated
 */
export type ConnectionSearchOptions = {
  cursor?: Maybe<Scalars['ID']>;
  sort?: Maybe<SortType>;
  offset?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type Contact = {
  __typename?: 'Contact';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  address3?: Maybe<Scalars['String']>;
  atlassianAccountId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  countCustomerDomain?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  customerDomain?: Maybe<Scalars['String']>;
  dataSources?: Maybe<Array<Maybe<DataSource>>>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  idType?: Maybe<IdType>;
  isoCountryCode?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  partnerType?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['Float']>;
  sourceSystem: Scalars['String'];
  sourceSystemId: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  status?: Maybe<ContactStatus>;
  taxId?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type ContactConnection = Connection & {
  __typename?: 'ContactConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<ContactEdge>>>;
  nodes?: Maybe<Array<Maybe<Contact>>>;
};

/**
 * @deprecated
 */
export type ContactEdge = Edge & {
  __typename?: 'ContactEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<Contact>;
};

/**
 * @deprecated
 */
export enum ContactStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

/**
 * @deprecated
 */
export type ContentMeta = {
  __typename?: 'ContentMeta';
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type CreditCard = PaymentMethod & {
  __typename?: 'CreditCard';
  id?: Maybe<Scalars['String']>;
  type: PaymentMethodType;
  default?: Maybe<Scalars['Boolean']>;
  paymentIssue?: Maybe<Scalars['Boolean']>;
  card?: Maybe<CreditCardDetails>;
};

/**
 * @deprecated
 */
export type CreditCardDetails = {
  __typename?: 'CreditCardDetails';
  expirationMonth?: Maybe<Scalars['String']>;
  expirationYear?: Maybe<Scalars['String']>;
  last4Numbers?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  cardHolderName?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export enum Currency {
  USD = 'USD',
  AUD = 'AUD',
  JPY = 'JPY',
  EUR = 'EUR',
  GBP = 'GBP',
}

/**
 * @deprecated
 */
export enum CycleInterval {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

/**
 * @deprecated
 */
export type DataSource = {
  __typename?: 'DataSource';
  sourceId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
};

/**
 * Health of the graph by basic dependency checks
 * @deprecated
 */
export type DependencyHealth = {
  __typename?: 'DependencyHealth';
  key: Scalars['String'];
  label: Scalars['String'];
  successful: Scalars['Boolean'];
};

/**
 * @deprecated
 */
export type DirectMatch = {
  __typename?: 'DirectMatch';
  entity?: Maybe<GraphEntity>;
  id?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  /** for child entities, also return parent type (think Entitlement <-> Add-on relationship) */
  parentEntity?: Maybe<GraphEntity>;
  /** for child entities, also return identifier type (think Entitlement <-> Add-on relationship) */
  parentIdentifier?: Maybe<Scalars['String']>;
  sourceSystem?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type Domain = {
  __typename?: 'Domain';
  /**
   * The account team that services and supports a  customer. Useful for support
   * teams to know who to talk to when problems arise.
   *
   * Examples: Customer Success Manager, Loyalty Advocate, Enterprise Advocate
   */
  salesforceAccountTeam?: Maybe<Array<Maybe<SalesforceAccountMember>>>;
  serverLicenses?: Maybe<ServerLicenseConnection>;
  cloudSites?: Maybe<CloudSiteConnection>;
  serviceLicenses?: Maybe<ServiceLicenseConnection>;
};

/**
 * @deprecated
 */
export type DomainServerLicensesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * @deprecated
 */
export type DomainCloudSitesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * @deprecated
 */
export type DomainServiceLicensesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * A type that is returned in list form by a connection type’s edges field is
 * considered by this spec to be an Edge Type. Edge types must be an “Object” as
 * defined in the “Type System” section of the GraphQL Specification.
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm#sec-Edges)
 * @deprecated
 */
export type Edge = {
  cursor?: Maybe<Scalars['ID']>;
};

/**
 * @deprecated
 */
export type EligibilityRule = {
  __typename?: 'EligibilityRule';
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  cycleInterval?: Maybe<Array<Maybe<CycleInterval>>>;
  pricingType?: Maybe<Array<Maybe<PricingType>>>;
  partnerType?: Maybe<Array<Maybe<Scalars['String']>>>;
  partnerTier?: Maybe<Array<Maybe<Scalars['String']>>>;
  saleTransitionType?: Maybe<Array<Maybe<Scalars['String']>>>;
  currency?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * Transactional billing emails sent to customers.
 * @deprecated
 */
export type Email = {
  __typename?: 'Email';
  subject?: Maybe<Scalars['String']>;
  to?: Maybe<Array<Maybe<EmailAddress>>>;
  from?: Maybe<Array<Maybe<EmailAddress>>>;
  date?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
};

/**
 * @deprecated
 */
export type EmailAddress = {
  __typename?: 'EmailAddress';
  address?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type EmailConnection = Connection & {
  __typename?: 'EmailConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<EmailEdge>>>;
};

/**
 * @deprecated
 */
export type EmailEdge = Edge & {
  __typename?: 'EmailEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: Email;
};

/**
 * @deprecated
 */
export type EmailSearchParams = {
  __typename?: 'EmailSearchParams';
  term?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type Attachment = {
  checksum?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  contentDisposition?: Maybe<Scalars['String']>;
  contentId?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  self?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
};

/**
 * Base type from which all product entitlements extend. This contains the
 * minimal amount fields that should be expected on all entitlements.
 * Any queries that return this Entitlement interface will also return any
 * types extended from Entitlement.
 * @deprecated
 */
export type Entitlement = {
  id: Scalars['ID'];
  offering?: Maybe<Offering>;
  pricingPlan?: Maybe<PricingPlan>;
  /** AKA Invoice Group Id: foreign key to invoice group used to pay for the entitlement's subscriptions. */
  billingGroupId?: Maybe<Scalars['String']>;
  hasPendingInvoices?: Maybe<Scalars['Boolean']>;
  productName?: Maybe<Scalars['String']>;
  businessKey?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type EntitlementDataSource = {
  __typename?: 'EntitlementDataSource';
  bitbucketAuthUser?: Maybe<Scalars['String']>;
  hamsAccount?: Maybe<Scalars['String']>;
  hamsLicense?: Maybe<Scalars['String']>;
  hipchatSubscriptions?: Maybe<Scalars['String']>;
  pakoLicense?: Maybe<Scalars['String']>;
  shopSubscriber?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceTable?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
  trello?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type EntitlementPeriod = {
  __typename?: 'EntitlementPeriod';
  baseProduct?: Maybe<Scalars['String']>;
  billTo?: Maybe<BillTo>;
  billingFrequency?: Maybe<BillingFrequency>;
  bitbucketUserProfileType?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  customerAccountId?: Maybe<Scalars['String']>;
  customerDomain?: Maybe<Scalars['String']>;
  dataSources?: Maybe<Array<Maybe<DataSource>>>;
  edition?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  licenseLevel?: Maybe<Scalars['String']>;
  parentSen?: Maybe<Scalars['String']>;
  partnerAccountId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  periodEndDate?: Maybe<Scalars['String']>;
  periodStartDate?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  previousEntitlementPeriodId?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  shipTo?: Maybe<BillTo>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['Float']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type Example = {
  __typename?: 'Example';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/**
 * @deprecated
 */
export type ExampleConnection = {
  __typename?: 'ExampleConnection';
  totalCount?: Maybe<Scalars['Int']>;
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<ExampleEdge>>>;
};

/**
 * @deprecated
 */
export type ExampleEdge = {
  __typename?: 'ExampleEdge';
  cursor: Scalars['ID'];
  node?: Maybe<Example>;
};

/**
 * @deprecated
 */
export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  flagKey: Scalars['String'];
  isEnabled: Scalars['Boolean'];
};

/**
 * Graph entity is an enumeration of the different objects that's information is then aggregated within the graph
 * @deprecated
 */
export enum GraphEntity {
  PERSON = 'PERSON',
  ORGANIZATION = 'ORGANIZATION',
  PARTNER_ACCOUNT = 'PARTNER_ACCOUNT',
  SUPPORT_ISSUE = 'SUPPORT_ISSUE',
  EMAIL = 'EMAIL',
  DOMAIN = 'DOMAIN',
  INVOICE = 'INVOICE',
  QUOTE = 'QUOTE',
  REFUND = 'REFUND',
  TRANSACTION_ACCOUNT = 'TRANSACTION_ACCOUNT',
  TRANSACTION_ACCOUNT_V2 = 'TRANSACTION_ACCOUNT_V2',
  ATLASSIAN_ACCESS = 'ATLASSIAN_ACCESS',
  BITBUCKET = 'BITBUCKET',
  CLOUD_SITE = 'CLOUD_SITE',
  ENTITLEMENT = 'ENTITLEMENT',
  OPSGENIE = 'OPSGENIE',
  SERVER_LICENSE = 'SERVER_LICENSE',
  SERVICE_LICENSE = 'SERVICE_LICENSE',
  STATUSPAGE = 'STATUSPAGE',
  TRELLO = 'TRELLO',
  /** this can be an add-on, marketplace app, or right now Jira / Confluence */
  CHILD_PRODUCT = 'CHILD_PRODUCT',
  CCP_ENTITLEMENT = 'CCP_ENTITLEMENT',
}

/**
 * @deprecated
 */
export enum IdType {
  Email = 'Email',
  AAID = 'AAID',
}

/**
 * @deprecated
 */
export type Invoice = {
  __typename?: 'Invoice';
  billTo?: Maybe<InvoiceBillAndShipTo>;
  billingContactName?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingFrequencyInterval?: Maybe<Scalars['Int']>;
  billingGroupId?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  creditCardExpiryMonth?: Maybe<Scalars['String']>;
  creditCardExpiryYear?: Maybe<Scalars['String']>;
  creditCardHolderName?: Maybe<Scalars['String']>;
  creditCardMaskedNumber?: Maybe<Scalars['String']>;
  creditCard: Maybe<CreditCardDetails>;
  customerAccountId?: Maybe<Scalars['String']>;
  customerDomain?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  grandTotal?: Maybe<Scalars['Float']>;
  grandTotalPaymentCurrency?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalPaymentCurrency?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  invoiceContactEmails?: Maybe<Array<Maybe<InvoiceContactEmails>>>;
  invoiceLineItems?: Maybe<Array<Maybe<InvoiceLineItems>>>;
  invoiceNumber?: Maybe<Scalars['String']>;
  itemsCount?: Maybe<Scalars['Int']>;
  itemsSubtotal?: Maybe<Scalars['Float']>;
  itemsTotal?: Maybe<Scalars['Float']>;
  itemsTotalPaymentCurrency?: Maybe<Scalars['Float']>;
  notes?: Maybe<Array<Maybe<AdditionalNotes>>>;
  orderId?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<InvoiceOrderStatus>;
  partnerAccountId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  paymentCurrency?: Maybe<Scalars['String']>;
  paymentMadeByEmail?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<InvoicePaymentMethod>;
  paymentTerms?: Maybe<InvoicePaymentTerms>;
  paypalAccountEmail?: Maybe<Scalars['String']>;
  previousInvoiceId?: Maybe<Scalars['String']>;
  pricingCurrency?: Maybe<Scalars['String']>;
  promotionCode?: Maybe<Scalars['String']>;
  purchaseOrder?: Maybe<Scalars['String']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  purchaserEmail?: Maybe<Scalars['String']>;
  refunds?: Maybe<Array<Maybe<Refunds>>>;
  revisionNumber?: Maybe<Scalars['String']>;
  serviceCreditAmount?: Maybe<Scalars['Float']>;
  shipTo?: Maybe<InvoiceBillAndShipTo>;
  slaCreditApplications?: Maybe<Array<Maybe<SlaCreditApplications>>>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['Float']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  status?: Maybe<InvoiceStatus>;
  statusReason?: Maybe<Scalars['String']>;
  taxIdentifier?: Maybe<Scalars['String']>;
  taxIdentifierType?: Maybe<Scalars['String']>;
  taxRate?: Maybe<InvoiceTaxRate>;
  taxes?: Maybe<Scalars['String']>;
  taxesPaymentCurrency?: Maybe<Scalars['Float']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
  upgradeCredits?: Maybe<Scalars['String']>;
  dunningStatus?: Maybe<Array<Maybe<DunningStatus>>>;
  transactionAccount?: Maybe<Array<TransactionAccount>>;
};

/**
 * @deprecated
 */
export type DunningStatus = {
  __typename?: 'DunningStutus';
  errorCode?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type InvoiceBillAndShipTo = {
  __typename?: 'InvoiceBillAndShipTo';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  address1: Maybe<Scalars['String']>;
  address2: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  companyName: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type InvoiceConnection = Connection & {
  __typename?: 'InvoiceConnection';
  totalCount?: Maybe<Scalars['Int']>;
  pageInfo?: Maybe<PageInfo>;
  nodes?: Maybe<Array<Maybe<Invoice>>>;
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>;
};

/**
 * @deprecated
 */
export type InvoiceContactEmails = {
  __typename?: 'InvoiceContactEmails';
  items?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type InvoiceDiscounts = {
  __typename?: 'InvoiceDiscounts';
  discountAmount?: Maybe<Scalars['Float']>;
  discountAmountLocal?: Maybe<Scalars['Float']>;
  discountReason?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type InvoiceEdge = Edge & {
  __typename?: 'InvoiceEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<Invoice>;
};

/**
 * a logical grouping of subscriptions for the purpose of creating an invoice.
 * contains the properties needed to construct an invoice.  (ship-to, subscriptions, invoice date…)
 * See more: [CCP Glossary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 * @deprecated
 */
export type InvoiceGroup = {
  __typename?: 'InvoiceGroup';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  updatePaymentMethodLink?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  transactionAccountNumber?: Maybe<Scalars['String']>;
  sourceSystem?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  shipToParty?: Maybe<CommerceAddress>;
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  invoiceToRecipients?: Maybe<Array<Maybe<Scalars['String']>>>;
  products?: Maybe<InvoiceGroupProductConnection>;
  recipients?: Maybe<Array<Maybe<Scalars['String']>>>;
  transactionAccount?: Maybe<TransactionAccount>;
  purchaseOrder?: Maybe<InvoiceGroupPurchaseOrder>;
  shipToPriceEligibility?: Maybe<Scalars['String']>;
};

/**
 * a logical grouping of subscriptions for the purpose of creating an invoice.
 * contains the properties needed to construct an invoice.  (ship-to, subscriptions, invoice date…)
 * See more: [CCP Glossary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 * @deprecated
 */
export type InvoiceGroupProductsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * @deprecated
 */
export type InvoiceGroupConnection = Connection & {
  __typename?: 'InvoiceGroupConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<InvoiceGroupEdge>>;
  nodes: Array<Maybe<InvoiceGroup>>;
};

/**
 * @deprecated
 */
export type InvoiceGroupEdge = Edge & {
  __typename?: 'InvoiceGroupEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: InvoiceGroup;
};

/**
 * @deprecated
 */
export type InvoiceGroupProduct = {
  __typename?: 'InvoiceGroupProduct';
  billingFrequency?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  baseProduct?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type InvoiceGroupProductConnection = Connection & {
  __typename?: 'InvoiceGroupProductConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<InvoiceGroupProductEdge>>>;
  nodes?: Maybe<Array<Maybe<InvoiceGroupProduct>>>;
};

/**
 * @deprecated
 */
export type InvoiceGroupProductEdge = Edge & {
  __typename?: 'InvoiceGroupProductEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: InvoiceGroupProduct;
};

/**
 * @deprecated
 */
export type InvoiceGroupPurchaseOrder = {
  __typename?: 'InvoiceGroupPurchaseOrder';
  number?: Maybe<Scalars['String']>;
  oneTimeUse?: Maybe<Scalars['Boolean']>;
};

/**
 * @deprecated
 */
export type InvoiceLineItems = {
  __typename?: 'InvoiceLineItems';
  accountName?: Maybe<Scalars['String']>;
  additionalNotes?: Maybe<Array<Maybe<AdditionalNotes>>>;
  amount?: Maybe<Scalars['String']>;
  amountPaymentCurrency?: Maybe<Scalars['Float']>;
  baseProduct?: Maybe<Scalars['String']>;
  billingType?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  contractModified?: Maybe<Scalars['String']>;
  dataSources?: Maybe<Array<Maybe<DataSource>>>;
  description?: Maybe<Scalars['String']>;
  discounts?: Maybe<Array<Maybe<InvoiceDiscounts>>>;
  edition?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  entitlement?: Maybe<Array<Maybe<Entitlement>>>;
  entitlementGroupId?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  entitlementKey?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  entitlementPeriodId?: Maybe<Scalars['String']>;
  externalNotes?: Maybe<Scalars['String']>;
  invoiceLineItemId?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Scalars['Float']>;
  listPricePaymentCurrency?: Maybe<Scalars['Float']>;
  parentBaseProduct?: Maybe<Scalars['String']>;
  parentEntitlementKey?: Maybe<Scalars['String']>;
  parentProductKey?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  previousInvoiceItemId?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  productCatalogId?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  proratedPrice?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  renewalListPrice?: Maybe<Scalars['Float']>;
  saleAction?: Maybe<Scalars['String']>;
  saleType?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Float']>;
  taxAmountPaymentCurrency?: Maybe<Scalars['Float']>;
  taxExemptAmountPaymentCurrency?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalPaymentCurrency?: Maybe<Scalars['Float']>;
  unitCount?: Maybe<Scalars['Float']>;
  unitLabel?: Maybe<Scalars['String']>;
  upgradeCredit?: Maybe<Scalars['Float']>;
  vendorAmount?: Maybe<Scalars['Float']>;
  vendorPaymentCurrency?: Maybe<Scalars['Float']>;
  vendorId?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type InvoiceOrderStatus = {
  __typename?: 'InvoiceOrderStatus';
  completed?: Maybe<Scalars['Boolean']>;
  successful?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  orderReference?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export enum InvoicePaymentMethod {
  NOPAYMENT = 'NOPAYMENT',
  NULL = 'NULL',
  PAID = 'PAID',
  PAIDCC = 'PAIDCC',
  PAIDONACCOUNT = 'PAIDONACCOUNT',
  PAIDPAYPAL = 'PAIDPAYPAL',
  PAID_BANK = 'PAID_BANK',
  PAID_ON_TERMS = 'PAID_ON_TERMS',
  STRIPE_CARD = 'STRIPE_CARD',
  DEFERRED = 'DEFERRED',
}

/**
 * @deprecated
 */
export enum InvoicePaymentTerms {
  PAY_ON_ACCOUNT = 'PAY_ON_ACCOUNT',
  PAY_CC = 'PAY_CC',
}

/**
 * @deprecated
 */
export enum InvoiceStatus {
  INVOICED = 'INVOICED',
  PAID = 'PAID',
  CREATED = 'CREATED',
  DECLINED = 'DECLINED',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  OPEN = 'OPEN',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  REFUNDED = 'REFUNDED',
  RESERVED = 'RESERVED',
  UNCOLLECTIBLE = 'UNCOLLECTIBLE',
  VOID = 'VOID',
  PAYMENT_DEFERRED = 'PAYMENT_DEFERRED',
}

/**
 * @deprecated
 */
export type InvoiceTaxRate = {
  __typename?: 'InvoiceTaxRate';
  displayName?: Maybe<Scalars['String']>;
  isoCountryCode?: Maybe<Scalars['String']>;
  taxIdLabel?: Maybe<Scalars['String']>;
  taxType?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type LineItem = {
  __typename?: 'LineItem';
  accountName?: Maybe<Scalars['String']>;
  additionalNotes?: Maybe<Array<Maybe<Note>>>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discounts?: Maybe<Array<Maybe<LineItemDiscount>>>;
  endDate?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  monthsValid?: Maybe<Scalars['Float']>;
  platform?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  proratedPrice?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
  saleAction?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Float']>;
  taxAmount?: Maybe<Scalars['Float']>;
  taxExemptAmount?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  unitCount?: Maybe<Scalars['Float']>;
  unitLabel?: Maybe<Scalars['String']>;
  upgradeCredit?: Maybe<Scalars['Float']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  dataSources?: Maybe<Array<Maybe<DataSource>>>;
  billTo?: Maybe<BillTo>;
  shipTo?: Maybe<BillTo>;
  sourceSequence?: Maybe<Scalars['String']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type LineItemDiscount = {
  __typename?: 'LineItemDiscount';
  discountAmount?: Maybe<Scalars['Float']>;
  discountReason?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type SupportIssue = {
  __typename?: 'SupportIssue';
  id: Scalars['Int'];
  issueKey?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  reporterEmailAddress?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type SupportIssueEdge = {
  __typename?: 'SupportIssueEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<SupportIssue>;
};

/**
 * @deprecated
 */
export type SupportIssues = {
  __typename?: 'SupportIssues';
  totalHits: Scalars['Int'];
  supportIssues: Array<Maybe<SupportIssue>>;
};

/**
 * @deprecated
 */
export type SupportIssuesConnection = {
  __typename?: 'SupportIssuesConnection';
  totalCount: Scalars['Int'];
  pageInfo?: Maybe<PageInfo>;
  edges: Array<Maybe<SupportIssueEdge>>;
};

/**
 * @deprecated
 */
export type NavigationGroup = {
  __typename?: 'NavigationGroup';
  name?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<NavigationLink>>>;
};

/**
 * @deprecated
 */
export type NavigationItem = NavigationGroup | NavigationLink;

/**
 * @deprecated
 */
export type NavigationLink = {
  __typename?: 'NavigationLink';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type Note = {
  __typename?: 'Note';
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

/**
 * A combination of a product and the edition/plan. Examples: _Confluence Free_, _Trello Business Class_.
 *
 * See more: [Tintin CCP Glosary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 * @deprecated
 */
export type Offering = {
  __typename?: 'Offering';
  /** Add ons eligible to be added to this offering */
  availableAddOns?: Maybe<Array<Maybe<AddOn>>>;
  /** Synthetic pricing plans eligible to be applied to this offering */
  availableSyntheticPricingPlans?: Maybe<Array<Maybe<SyntheticPricingPlan>>>;
  id: Scalars['String'];
  key?: Maybe<Scalars['String']>;
  /** offering-level for upgrade or downgrade */
  level?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  pricingType?: Maybe<Scalars['String']>;
  productKey?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  slugs?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type Opportunity = {
  __typename?: 'Opportunity';
  id: Scalars['ID'];
  accountName?: Maybe<Scalars['String']>;
  sourceSequence: Scalars['String'];
  sourceSystem: Scalars['String'];
  sourceSystemId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  opportunityId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  recordtypeName?: Maybe<Scalars['String']>;
  stageName?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  partnerAccountId?: Maybe<Scalars['String']>;
  reasonForPurchase?: Maybe<Scalars['String']>;
  closeDate?: Maybe<Scalars['String']>;
  saleType?: Maybe<Scalars['String']>;
  customerTechnicalContact?: Maybe<Scalars['String']>;
  customerTechnicalContactUuid?: Maybe<Scalars['String']>;
  shipTo?: Maybe<CommerceAddress>;
  billTo?: Maybe<CommerceAddress>;
  subscriptionTerm?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['String']>;
  partnerDiscount?: Maybe<Scalars['String']>;
  netOrderAmount?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  ectlSen?: Maybe<Scalars['String']>;
  cloudHostSen?: Maybe<Scalars['String']>;
  renewalInvoice?: Maybe<Scalars['String']>;
  quote?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['String']>;
  dpe?: Maybe<Scalars['String']>;
  renewed?: Maybe<Scalars['String']>;
  currencyIsoCode?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  lastmodifiedDate?: Maybe<Scalars['String']>;
  opportunityLineItems?: Maybe<Array<Maybe<OpportunityLineItem>>>;
};

/**
 * @deprecated
 */
export type OpportunityConnection = Connection & {
  __typename?: 'OpportunityConnection';
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<OpportunityEdge>>>;
  nodes?: Maybe<Array<Maybe<Opportunity>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/**
 * @deprecated
 */
export type OpportunityEdge = Edge & {
  __typename?: 'OpportunityEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<Opportunity>;
};

/**
 * @deprecated
 */
export type OpportunityLineItem = {
  __typename?: 'OpportunityLineItem';
  opportunityLineId?: Maybe<Scalars['String']>;
  inventoryProductId?: Maybe<Scalars['String']>;
  inventoryProductName?: Maybe<Scalars['String']>;
  offeringId?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Scalars['String']>;
  salesPrice?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<Scalars['String']>;
  priceAdjustment?: Maybe<Scalars['String']>;
  upgradeCredit?: Maybe<Scalars['String']>;
  partnerDiscount?: Maybe<Scalars['String']>;
  otherDiscount?: Maybe<Scalars['String']>;
  netOrderAmount?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  lastModifiedDate?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type Opsgenie = {
  __typename?: 'Opsgenie';
  id: Scalars['ID'];
  baseProduct: Scalars['String'];
  plan?: Maybe<Scalars['String']>;
  firstPeriodEndDate?: Maybe<Scalars['String']>;
  renewalAction?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
};

/**
 * An action that results in a subscription change. This can be an amendment, creation, deletion.
 *
 * Transaction Account A. amended their subscription to include a new add-on.
 * @deprecated
 */
export type Order = {
  __typename?: 'Order';
  billTo?: Maybe<OrderBillTo>;
  billingContactEmail?: Maybe<Scalars['String']>;
  billingGroup?: Maybe<OrderBillingGroup>;
  /** // TODO: Convert to subject to direct link to contact or system */
  contextSubject?: Maybe<Scalars['String']>;
  /** Date the order was created, represents the sourceSequence in Hydra (date in epoch) */
  created?: Maybe<Scalars['String']>;
  hasPendingInvoice?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoiceGroup?: Maybe<InvoiceGroup>;
  metadata?: Maybe<OrderMetadata>;
  orderContext?: Maybe<OrderContext>;
  orderLineItems?: Maybe<OrderLineItemConnection>;
  /** Human readable identifier */
  orderNumber?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type OrderBillingGroup = {
  __typename?: 'OrderBillingGroup';
  billingGroupId?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type OrderConnection = Connection & {
  __typename?: 'OrderConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  nodes: Array<Maybe<Order>>;
  edges: Array<Maybe<OrderEdge>>;
};

/**
 * The person or system that is responsible for the action taking place
 * @deprecated
 */
export type OrderContext = Contact;

/**
 * @deprecated
 */
export type OrderEdge = Edge & {
  __typename?: 'OrderEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<Order>;
};

/**
 * @deprecated
 */
export enum OrderItemRequestType {
  CREATION_ORDER = 'CREATION_ORDER',
  AMENDMENT_ORDER = 'AMENDMENT_ORDER',
  CANCELLATION_ORDER = 'CANCELLATION_ORDER',
  SYSTEM_CANCELLATION_ORDER = 'SYSTEM_CANCELLATION_ORDER',
  SYSTEM_AMENDMENT_ORDER = 'SYSTEM_AMENDMENT_ORDER',
  REACTIVATION_ORDER = 'REACTIVATION_ORDER',
  ACCOUNT_MODIFICATION_ORDER = 'ACCOUNT_MODIFICATION_ORDER',
  REWIND_ORDER = 'REWIND_ORDER',
}

/**
 * An action that results in a subscription change. This can be an amendment, creation, deletion.
 * @deprecated
 */
export type OrderLineItem = {
  __typename?: 'OrderLineItem';
  lineItemId: Scalars['ID'];
  entitlementId: Scalars['ID'];
  parentEntitlementId?: Maybe<Scalars['ID']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['ID']>;
  status?: Maybe<OrderStatus>;
  type?: Maybe<OrderItemRequestType>;
  quantity?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['String']>;
  promotionCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  pricingPlan?: Maybe<PricingPlan>;
  offering?: Maybe<Offering>;
  offeringId?: Maybe<Scalars['String']>;
  skipTrial?: Maybe<Scalars['Boolean']>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  orderTransitionType?: Maybe<Scalars['String']>;
  salesTransitionType?: Maybe<Scalars['String']>;
  orderLineItemsPurchaseMetadata?: Maybe<Array<Maybe<OrderLineItemsPurchaseMetadataType>>>;
  orderLineItemsAdditionalNotes?: Maybe<Scalars['String']>;
};
/**
 * @deprecated
 */
export type OrderLineItemsPurchaseMetadataType = {
  __typename?: 'orderLineItemsPurchaseMetadataType';
  fieldName?: Maybe<Scalars['String']>;
  fieldValue?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type OrderLineItemConnection = Connection & {
  __typename?: 'OrderLineItemConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  nodes: Array<Maybe<OrderLineItem>>;
  edges: Array<Maybe<OrderLineItemEdge>>;
};

/**
 * @deprecated
 */
export type OrderLineItemEdge = Edge & {
  __typename?: 'OrderLineItemEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<OrderLineItem>;
};

/**
 * @deprecated
 */
export type OrderMetadata = {
  __typename?: 'OrderMetadata';
  supportTicketNumber?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export enum OrderStatus {
  FAIL = 'FAIL',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
}

/**
 * @deprecated
 */
export type Organization = {
  __typename?: 'Organization';
  id: Scalars['ID'];
  name: Scalars['String'];
  atlassianAccess?: Maybe<AtlassianAccess>;
  products: CloudProductConnection;
  aggregatedProducts?: Maybe<Array<Maybe<AggregatedProduct>>>;
};

/**
 * @deprecated
 */
export type OrganizationProductsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * Information about pagination in a connection
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo)
 * @deprecated
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
};

/**
 * Derive specific payment method information based on the type (Credit Card, Payment on Terms, etc).
 * @deprecated
 */
export type PaymentMethod = {
  id?: Maybe<Scalars['String']>;
  type: PaymentMethodType;
  default?: Maybe<Scalars['Boolean']>;
  paymentIssue?: Maybe<Scalars['Boolean']>;
};

/**
 * @deprecated
 */
export type PaymentMethodConnection = Connection & {
  __typename?: 'PaymentMethodConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<PaymentMethodEdge>>>;
  nodes?: Maybe<Array<Maybe<PaymentMethod>>>;
};

/**
 * @deprecated
 */
export type PaymentMethodEdge = Edge & {
  __typename?: 'PaymentMethodEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: PaymentMethod;
};

/**
 * @deprecated
 */
export enum PaymentMethodType {
  CARD = 'CARD',
  DEFERRED = 'DEFERRED',
}

export enum PaymentMethodTypeV2 {
  CARD = 'CARD',
  DEFERRED = 'DEFERRED',
  PAYPAL = 'PAYPAL',
  ACH = 'ACH',
}

/**
 * @deprecated
 */
export type PaymentOnTerms = PaymentMethod & {
  __typename?: 'PaymentOnTerms';
  id?: Maybe<Scalars['String']>;
  type: PaymentMethodType;
  default?: Maybe<Scalars['Boolean']>;
  paymentIssue?: Maybe<Scalars['Boolean']>;
  terms?: Maybe<PaymentOnTermsDetails>;
};

/**
 * @deprecated
 */
export type PaymentOnTermsDetails = {
  __typename?: 'PaymentOnTermsDetails';
  invoiceDueDays?: Maybe<Scalars['Int']>;
};

/**
 * @deprecated
 */
export enum PaymentTerms {
  PAY_CC = 'PAY_CC',
  PAY_ON_ACCOUNT = 'PAY_ON_ACCOUNT',
}

/**
 * @deprecated
 */
export type Period = {
  __typename?: 'Period';
  start?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export enum Permission {
  BITBUCKET_ADMIN = 'BITBUCKET_ADMIN',
  BITBUCKET_CHANGE_PLAN = 'BITBUCKET_CHANGE_PLAN',
  CASSI_ADMIN = 'CASSI_ADMIN',
  CASSI_DISTURBED = 'CASSI_DISTURBED',
  CHANGE_RENEWAL_ACTION = 'CHANGE_RENEWAL_ACTION',
  CLOSE_ACCOUNT = 'CLOSE_ACCOUNT',
  CLOUD_SITE_DEACTIVATION = 'CLOUD_SITE_DEACTIVATION',
  CLOUD_SITE_DELETION = 'CLOUD_SITE_DELETION',
  CLOUD_SITE_PRODUCTS_DEACTIVATION = 'CLOUD_SITE_PRODUCTS_DEACTIVATION',
  CLOUD_SITE_REACTIVATION = 'CLOUD_SITE_REACTIVATION',
  CONTACT_READ = 'CONTACT_READ',
  COUPONS_READ = 'COUPONS_READ',
  COUPONS_WRITE = 'COUPONS_WRITE',
  CREDIT_READ = 'CREDIT_READ',
  CREDIT_WRITE = 'CREDIT_WRITE',
  DEAL_DESK = 'DEAL_DESK',
  EMAIL_READ = 'EMAIL_READ',
  ENTITLEMENT_READ = 'ENTITLEMENT_READ',
  EXPORT_CONTROLS_WRITE = 'EXPORT_CONTROLS_WRITE',
  EXTEND_CLOUD_TRIAL = 'EXTEND_CLOUD_TRIAL',
  FINANCE_USER = 'FINANCE_USER',
  GENERATE_LICENSE_REPORT = 'GENERATE_LICENSE_REPORT',
  IMPERSONATE_SITE_ADMIN = 'IMPERSONATE_SITE_ADMIN',
  INVOICE_READ = 'INVOICE_READ',
  MANAGE_BILLING = 'MANAGE_BILLING',
  MANAGE_EXTENDED_CLOUD_TRIAL = 'MANAGE_EXTENDED_CLOUD_TRIAL',
  OBFUSCATE_ACCOUNT = 'OBFUSCATE_ACCOUNT',
  PARTNER_ACCOUNT_READ = 'PARTNER_ACCOUNT_READ',
  PROCESS_REFUND = 'PROCESS_REFUND',
  QUOTE_READ = 'QUOTE_READ',
  REFUND_READ = 'REFUND_READ',
  RENAME_CLOUD_SITE = 'RENAME_CLOUD_SITE',
  RESEND_IDENTITY_LINKS = 'RESEND_IDENTITY_LINKS',
  STAFFID_LOGIN = 'STAFFID_LOGIN',
  TICKET_READ = 'TICKET_READ',
  UPDATE_ADD_ON_SUBSCRIPTIONS = 'UPDATE_ADD_ON_SUBSCRIPTIONS',
  USER_READ = 'USER_READ',
}

/**
 * A container that groups together transaction-related entities for a contact/person.
 * @deprecated
 */
export type Person = {
  __typename?: 'Person';
  emailAddress?: Maybe<Scalars['String']>;
  transactionAccounts: TransactionAccountConnection;
  opportunities: OpportunityConnection;
};

/**
 * A container that groups together transaction-related entities for a contact/person.
 * @deprecated
 */
export type PersonTransactionAccountsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * A container that groups together transaction-related entities for a contact/person.
 * @deprecated
 */
export type PersonOpportunitiesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * @deprecated
 */
export type PlanObj = {
  __typename?: 'PlanObj';
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  hostingType?: Maybe<Scalars['String']>;
};

/**
 * Applications (micro-frontends) hosted elsewhere consumed by CASSI
 * @deprecated
 */
export type PortalApp = {
  __typename?: 'PortalApp';
  name: Scalars['String'];
  appId: Scalars['String'];
  url: Scalars['String'];
  enabled: Scalars['Boolean'];
};

/**
 * @deprecated
 */
export type PreviewThumbnail = {
  __typename?: 'PreviewThumbnail';
  link?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type PricingPlan = {
  __typename?: 'PricingPlan';
  id: Scalars['ID'];
  type: Scalars['String'];
  billingFrequency?: Maybe<BillingFrequency>;
};

/**
 * @deprecated
 */
export enum PricingType {
  FREE = 'FREE',
  LIMITED_FREE = 'LIMITED_FREE',
  PAID = 'PAID',
}

/**
 * @deprecated
 */
export type Promotion = {
  __typename?: 'Promotion';
  id?: Maybe<Scalars['String']>;
  benefits?: Maybe<Array<Maybe<Benefit>>>;
  maxRedemptionsCustomer?: Maybe<Scalars['Int']>;
  maxRedemptionsPromotion?: Maybe<Scalars['Int']>;
  promotionWindow?: Maybe<PromotionWindow>;
  status?: Maybe<Scalars['String']>;
  rule?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  eligibilityRules?: Maybe<EligibilityRule>;
  purpose?: Maybe<Purpose>;
  cycleInterval?: Maybe<Array<Maybe<CycleInterval>>>;
  pricingType?: Maybe<Array<Maybe<PricingType>>>;
  promotionReasonCode?: Maybe<Scalars['String']>;
  isPromotionCustomisable?: Maybe<Scalars['Boolean']>;
  applicationReason?: Maybe<PromotionReason>;
  cycleIntervalWithEligibleConditions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * @deprecated
 */
export type PromotionReason = {
  __typename?: 'PromotionReason';
  id?: Maybe<Scalars['String']>;
  readableName?: Maybe<Scalars['String']>;
  customisable?: Maybe<PromotionReasonCustomisable>;
};

/**
 * @deprecated
 */
export type PromotionReasonCustomisable = {
  __typename?: 'PromotionReasonCustomisable';
  id?: Maybe<PromotionReasonListObj>;
};

/**
 * @deprecated
 */
export type PromotionReasonListObj = {
  __typename?: 'PromotionReasonListObj';
  type?: Maybe<Scalars['String']>;
  anyOf?: Maybe<Array<Maybe<ReasonCustomisableObj>>>;
};

/**
 * @deprecated
 */
export type ReasonCustomisableObj = {
  __typename?: 'ReasonCustomisableObj';
  readableName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type PromotionWindow = {
  __typename?: 'PromotionWindow';
  endTime?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export enum ProvisioningStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  DEACTIVATED = 'DEACTIVATED',
  DELETED = 'DELETED',
}

/**
 * @deprecated
 */
export type Purpose = {
  __typename?: 'Purpose';
  reasonCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  invoiceNote?: Maybe<Scalars['String']>;
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type Query = {
  __typename?: 'Query';
  /** Determines if the graph is currently running */
  up: Scalars['Boolean'];
  /** Provides insight to if a dependency is currently accessible */
  deepcheck: Array<Maybe<DependencyHealth>>;
  auditNotesByContactKey: AuditNoteConnection;
  auditNotesByInvoiceKey: AuditNoteConnection;
  auditNotes: AuditNoteConnection;
  example: Example;
  examples?: Maybe<ExampleConnection>;
  /** get all available country information */
  availableCountries: BillingCountryConnection;
  /** get all available states for a given country's iso code */
  availableStatesForCountry: BillingCountryStateConnection;
  application?: Maybe<Application>;
  searchForDirectMatch?: Maybe<DirectMatch>;
  /** The user profile of the currently logged-in user */
  me?: Maybe<UserProfile>;
  invoice: Invoice;
  invoiceGroup?: Maybe<InvoiceGroup>;
  quote: Quote;
  refund?: Maybe<Array<Maybe<Refunds>>>;
  transactionAccount: TransactionAccount;
  domain?: Maybe<Domain>;
  entitlement: Entitlement;
  cloudSite: CloudSite;
  opsgenie?: Maybe<Opsgenie>;
  statuspage: Statuspage;
  trello: Trello;
  organization?: Maybe<Organization>;
  organizationByDomain?: Maybe<Organization>;
  personByEmailAddress?: Maybe<Person>;
  fetchAuditTrails?: Maybe<AuditNoteResult>;
  cloudSubscription?: Maybe<CloudSubscriptionConnection>;
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryAuditNotesByContactKeyArgs = {
  contactKey: Scalars['String'];
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryAuditNotesByInvoiceKeyArgs = {
  invoiceKey: Scalars['String'];
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryExampleArgs = {
  id?: Maybe<Scalars['ID']>;
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryAvailableStatesForCountryArgs = {
  isoCode?: Maybe<Scalars['String']>;
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryApplicationArgs = {
  id?: Maybe<Scalars['String']>;
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QuerySearchForDirectMatchArgs = {
  query?: Maybe<Scalars['String']>;
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryInvoiceArgs = {
  id: Scalars['ID'];
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryInvoiceGroupArgs = {
  id: Scalars['ID'];
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryQuoteArgs = {
  id: Scalars['ID'];
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryRefundArgs = {
  id: Scalars['ID'];
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryTransactionAccountArgs = {
  id: Scalars['ID'];
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryDomainArgs = {
  url: Scalars['String'];
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryEntitlementArgs = {
  id?: Maybe<Scalars['String']>;
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryCloudSiteArgs = {
  cloudSiteId: Scalars['ID'];
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryOpsgenieArgs = {
  id: Scalars['ID'];
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryStatuspageArgs = {
  id?: Maybe<Scalars['String']>;
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryTrelloArgs = {
  id: Scalars['ID'];
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryOrganizationByDomainArgs = {
  domain: Scalars['String'];
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryPersonByEmailAddressArgs = {
  email?: Maybe<Scalars['String']>;
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryFetchAuditTrailsArgs = {
  email: Scalars['String'];
  searchOptions?: Maybe<SearchOptions>;
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryFetchPartnerAccountsArgs = {
  email: Scalars['String'];
  searchOptions?: Maybe<SearchOptions>;
};

/**
 * Basic typing for querying the Atlassian Business Graph
 * @deprecated
 */
export type QueryCloudSubscriptionArgs = {
  searchParams: CloudSubscriptionSearchParams;
  searchOptions?: Maybe<SearchOptions>;
};

/**
 * @deprecated
 */
export type Quote = {
  __typename?: 'Quote';
  billingGroupId?: Maybe<Scalars['String']>;
  billTo?: Maybe<BillTo>;
  cartUuid?: Maybe<Scalars['String']>;
  createdDate: Scalars['String'];
  dataSources?: Maybe<Array<Maybe<DataSource>>>;
  eligibleForPayOnTerms?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['String']>;
  externalNotes?: Maybe<Scalars['String']>;
  grandTotal?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  itemsCount: Scalars['Float'];
  itemsSubtotal: Scalars['Float'];
  itemsTotal: Scalars['Float'];
  lineItems?: Maybe<Array<Maybe<LineItem>>>;
  notes?: Maybe<Array<Maybe<Note>>>;
  orderId?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  paymentCurrency?: Maybe<Currency>;
  paymentTerms?: Maybe<PaymentTerms>;
  promotionCode?: Maybe<Scalars['String']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  revisionNumber?: Maybe<Scalars['Float']>;
  slaCreditApplications?: Maybe<Array<Maybe<QuoteSlaCreditApplication>>>;
  shipTo?: Maybe<BillTo>;
  sourceId: Scalars['String'];
  sourceSequence?: Maybe<Scalars['Float']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  status?: Maybe<QuoteStatus>;
  statusReason?: Maybe<Scalars['String']>;
  statusSetBy?: Maybe<Scalars['String']>;
  taxes: Scalars['Float'];
  taxIdentifier?: Maybe<Scalars['String']>;
  taxIdentifierType?: Maybe<Scalars['String']>;
  taxRate?: Maybe<TaxRate>;
  updatedDate?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type QuoteSlaCreditApplication = {
  __typename?: 'QuoteSlaCreditApplication';
  amountExTax: Scalars['Float'];
  amountIncTax: Scalars['Float'];
  creditExternalId: Scalars['String'];
  createdAt: Scalars['String'];
  currency?: Maybe<Currency>;
  currencyExchangeRate?: Maybe<Scalars['Float']>;
  entitlementId?: Maybe<Scalars['String']>;
  modifiedAt: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  taxAmount: Scalars['Float'];
  taxRate: Scalars['Float'];
};

/**
 * @deprecated
 */
export enum QuoteStatus {
  DELETED = 'DELETED',
  PROCESSED = 'PROCESSED',
  QUOTED = 'QUOTED',
  REVIEW_REQUIRED = 'REVIEW_REQUIRED',
  SUPERSEDED = 'SUPERSEDED',
}

/**
 * @deprecated
 */
export type RefundItems = {
  __typename?: 'RefundItems';
  id?: Maybe<Scalars['String']>;
  entitlementId?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  taxPercent?: Maybe<Scalars['Float']>;
  invoiceLineItems?: Maybe<Array<Maybe<RefundLineItems>>>;
};

/**
 * @deprecated
 */
export type RefundLineItems = {
  __typename?: 'RefundLineItems';
  id?: Maybe<Scalars['String']>;
  period?: Maybe<Period>;
  subTotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  taxPercent?: Maybe<Scalars['Float']>;
  adjustments?: Maybe<Array<Maybe<Adjustments>>>;
  subscriptionObj?: Maybe<Array<Maybe<SubscriptionObj>>>;
  planObj?: Maybe<Array<Maybe<PlanObj>>>;
};

/**
 * @deprecated
 */
export type Refunds = {
  __typename?: 'Refunds';
  id: Scalars['String'];
  creditNoteNumber?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  refundId?: Maybe<Scalars['String']>;
  chargeId?: Maybe<Scalars['String']>;
  rechargeInvoiceId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  refundItems?: Maybe<Array<Maybe<RefundItems>>>;
  invoice?: Maybe<Invoice>;
  arn?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export enum Role {
  CASSI_DEVELOPER = 'CASSI_DEVELOPER',
  COMMERCE_DEV = 'COMMERCE_DEV',
  CST_DEVELOPER = 'CST_DEVELOPER',
  CUSTOMER_ADVOCATE = 'CUSTOMER_ADVOCATE',
  ENTERPRISE_ADVOCATE = 'ENTERPRISE_ADVOCATE',
  GOVERNATOR_ADMIN = 'GOVERNATOR_ADMIN',
  LOYALTY_ADVOCATE = 'LOYALTY_ADVOCATE',
  PRODUCT_ADVOCATE = 'PRODUCT_ADVOCATE',
  SALES_OPERATIONS = 'SALES_OPERATIONS',
}

/**
 * The Atlassian employee who provides additional support to a customer account.
 * @deprecated
 */
export type SalesforceAccountMember = {
  __typename?: 'SalesforceAccountMember';
  accountId?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  customerDomain?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  idType?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  slackInfo?: Maybe<SlackInfo>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['Int']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/**
 * A change to an entitlement scheduled to happen at a later time, often at the end of a billing cycle.
 * @deprecated
 */
export type ScheduledChanges = {
  __typename?: 'ScheduledChanges';
  /** Unix epoch time in milliseconds */
  nextChangeTimestamp?: Maybe<Scalars['Float']>;
  subscriptionScheduleAction?: Maybe<SubscriptionScheduleAction>;
  /** Updated offering */
  offering?: Maybe<Offering>;
  /** Updated pricing plan */
  pricingPlan?: Maybe<PricingPlan>;
  chargeQuantities?: Maybe<Array<Maybe<ChargeQuantity>>>;
  promotionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  scheduledBillingInvoiceGroupId?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type SearchOptions = {
  size?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['Int']>;
  cursor?: Maybe<Scalars['String']>;
  sort?: Maybe<SortType>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type ServerLicense = {
  __typename?: 'ServerLicense';
  baseProduct?: Maybe<Scalars['String']>;
  billingContactEmail?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  dataSource?: Maybe<EntitlementDataSource>;
  entitlementGroupId?: Maybe<Scalars['String']>;
  firstPeriodEndDate?: Maybe<Scalars['String']>;
  firstPeriodStartDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAddon?: Maybe<Scalars['Boolean']>;
  isCloud?: Maybe<Scalars['Boolean']>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  licenseLevel?: Maybe<Scalars['String']>;
  maintenancePeriod?: Maybe<Scalars['Int']>;
  planType?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  prioritySupport?: Maybe<Scalars['String']>;
  productCatalogId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  renewalAction?: Maybe<Scalars['String']>;
  sen?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sources?: Maybe<Array<Maybe<Scalars['String']>>>;
  sourceSequence?: Maybe<Scalars['Float']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type ServerLicenseConnection = Connection & {
  __typename?: 'ServerLicenseConnection';
  totalCount?: Maybe<Scalars['Int']>;
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<ServerLicenseEdge>>>;
  nodes?: Maybe<Array<Maybe<ServerLicense>>>;
};

/**
 * @deprecated
 */
export type ServerLicenseEdge = Edge & {
  __typename?: 'ServerLicenseEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<ServerLicense>;
};

/**
 * @deprecated
 */
export type ServiceLicense = {
  __typename?: 'ServiceLicense';
  accountOwnerEmail?: Maybe<Scalars['String']>;
  baseProduct?: Maybe<Scalars['String']>;
  billingContactEmail?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingGroupId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  bitbucketUserprofileType?: Maybe<Scalars['String']>;
  cloudSiteCustomHostname?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteSen?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  customerAccountId?: Maybe<Scalars['String']>;
  customerDomain?: Maybe<Scalars['String']>;
  dataSource?: Maybe<EntitlementDataSource>;
  edition?: Maybe<Scalars['String']>;
  entitlementGroupId?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  firstPeriodEndDate?: Maybe<Scalars['String']>;
  firstPeriodStartDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  licenseLevel?: Maybe<Scalars['String']>;
  licensedTo?: Maybe<Scalars['String']>;
  migrationEvaluationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  parentSen?: Maybe<Scalars['String']>;
  partnerAccountId?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['String']>;
  prioritySupport?: Maybe<Scalars['String']>;
  productCatalogId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  provisioningOverrideId?: Maybe<Scalars['String']>;
  renewalAction?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['Float']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceSystemId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
  vendorId?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type ServiceLicenseConnection = Connection & {
  __typename?: 'ServiceLicenseConnection';
  totalCount?: Maybe<Scalars['Int']>;
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<ServiceLicenseEdge>>>;
  nodes?: Maybe<Array<Maybe<ServiceLicense>>>;
};

/**
 * @deprecated
 */
export type ServiceLicenseEdge = Edge & {
  __typename?: 'ServiceLicenseEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<ServiceLicense>;
};

/**
 * @deprecated
 */
export type SiteAdmin = {
  __typename?: 'SiteAdmin';
  id: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  primaryEmail?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<UserRole>>>;
  lastActive?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type SiteAdminConnection = Connection & {
  __typename?: 'SiteAdminConnection';
  totalCount?: Maybe<Scalars['Int']>;
  pageInfo?: Maybe<PageInfo>;
  edges?: Maybe<Array<Maybe<SiteAdminEdge>>>;
  nodes?: Maybe<Array<Maybe<SiteAdmin>>>;
};

/**
 * @deprecated
 */
export type SiteAdminEdge = Edge & {
  __typename?: 'SiteAdminEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<SiteAdmin>;
};

/**
 * Associated Slack account information for an Atlassian. Useful for opening a direct message or sending information to
 * @deprecated
 */
export type SlackInfo = {
  __typename?: 'SlackInfo';
  slackTeamId?: Maybe<Scalars['String']>;
  slackUserId?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type SlaCreditApplications = {
  __typename?: 'SlaCreditApplications';
  amountExTax?: Maybe<Scalars['Float']>;
  amountIncTax?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  creditExternalId?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  currencyExchangeRate?: Maybe<Scalars['String']>;
  modifiedAt?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  taxAmount?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
};

/**
 * Direction to sort returned connection
 * @deprecated
 */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

/**
 * ElasticSearch Script for finely tuned sorts (used with Hydra)
 * @deprecated
 */
export type SortScript = {
  script?: Maybe<Scalars['String']>;
  returnType?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
};

/**
 * Available sort options; defaults to Hydra terminology
 * @deprecated
 */
export type SortType = {
  /** Fields to sort, must be equal length to sortFieldsDirections */
  sortFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Direction to sort, must be equal length to sortFields */
  sortFieldsDirections?: Maybe<Array<Maybe<SortDirection>>>;
  sortScript?: Maybe<Array<Maybe<SortScript>>>;
};

/**
 * @deprecated
 */
export type SubscriptionDetails = {
  __typename?: 'SubscriptionDetails';
  id?: Maybe<Scalars['String']>;
  sourceSystem?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceSequence?: Maybe<Scalars['Float']>;
  subscriptionPeriod?: Maybe<Array<Maybe<SubscriptionPeriodDetails>>>;
};

/**
 * @deprecated
 */
export type SubscriptionPeriodDetails = {
  __typename?: 'SubscriptionPeriodDetails';
  startTimestamp?: Maybe<Scalars['String']>;
  chargeQuantities?: Maybe<Array<Maybe<ChargeQuantity>>>;
};

/**
 * @deprecated
 */
export type Statuspage = Entitlement & {
  __typename?: 'Statuspage';
  activeSubscriptionBillingGroupId?: Maybe<Scalars['String']>;
  activeUsers?: Maybe<Scalars['Int']>;
  actualBilledUsers?: Maybe<Scalars['Int']>;
  addOns?: Maybe<AddOnConnection>;
  auditNotes?: Maybe<AuditNoteConnection>;
  availableOfferings?: Maybe<Array<Maybe<Offering>>>;
  availablePromotions?: Maybe<Array<Maybe<Promotion>>>;
  baseProduct?: Maybe<Scalars['String']>;
  billing?: Maybe<Billing>;
  billingCycle?: Maybe<Scalars['String']>;
  billingFrequency?: Maybe<Scalars['String']>;
  billingGroupId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  cloudSiteCustomHostname?: Maybe<Scalars['String']>;
  cloudSiteHostname?: Maybe<Scalars['String']>;
  cloudSiteId?: Maybe<Scalars['String']>;
  cloudSiteSen?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  edition?: Maybe<Scalars['String']>;
  emails?: Maybe<EmailConnection>;
  entitlementNumber?: Maybe<Scalars['String']>;
  hasPendingInvoices?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  invoices: InvoiceConnection;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  firstPeriodStartDate?: Maybe<Scalars['String']>;
  licenseLevel?: Maybe<Scalars['String']>;
  nextInvoiceTimeAt?: Maybe<Scalars['String']>;
  offering?: Maybe<Offering>;
  offeringId?: Maybe<Scalars['String']>;
  orders?: Maybe<OrderConnection>;
  ordersForRewind?: Maybe<OrderConnection>;
  orgId?: Maybe<Scalars['String']>;
  parentCloudSiteName?: Maybe<Scalars['String']>;
  parentSen?: Maybe<Scalars['String']>;
  partnerAccountId?: Maybe<Scalars['String']>;
  plan?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  pricingPlan?: Maybe<PricingPlan>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  provisioningStatus?: Maybe<Scalars['String']>;
  renewalAction?: Maybe<Scalars['String']>;
  scheduledChanges?: Maybe<ScheduledChanges>;
  siteAdmins?: Maybe<SiteAdminConnection>;
  sourceSystem?: Maybe<Scalars['String']>;
  subscription?: Maybe<Array<Maybe<SubscriptionDetails>>>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionTimestamps?: Maybe<SubscriptionTimeStamps>;
  subscriptionsEndTimestamp?: Maybe<Scalars['String']>;
  supportIssues?: Maybe<SupportIssues>;
  totalBilledUsers?: Maybe<Scalars['Int']>;
  nextBillEstimate?: Maybe<NextBillEstimate>;
  transactionAccount?: Maybe<TransactionAccount>;
  transactionAccountId?: Maybe<Scalars['String']>;
  trialPromotionDetails?: Maybe<TrialPromotionDetails>;
  unitCount?: Maybe<Scalars['String']>;
  updatePaymentMethodLink?: Maybe<Scalars['String']>;
  userHistory?: Maybe<Array<Maybe<ChargeQuantity>>>;
  users?: Maybe<UserConnection>;
  validOfferings?: Maybe<Array<Maybe<ValidOfferings>>>;
  version?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type NextBillEstimate = {
  total?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type StatuspageAddOnsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * @deprecated
 */
export type StatuspageAuditNotesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * @deprecated
 */
export type StatuspageEmailsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * @deprecated
 */
export type StatuspageInvoicesArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * @deprecated
 */
export type StatuspageOrdersArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * @deprecated
 */
export type StatuspageUsersArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * @deprecated
 */
export enum SubBenefitType {
  PERCENTAGE = 'PERCENTAGE',
  TRIAL = 'TRIAL',
  FLAT = 'FLAT',
  MULTI_PERCENTAGE = 'MULTI_PERCENTAGE',
  NONE = 'NONE',
}

/**
 * @deprecated
 */
export type Subscription = {
  __typename?: 'Subscription';
  subscriptionPeriod?: Maybe<Array<Maybe<SubscriptionPeriod>>>;
};

/**
 * @deprecated
 */
export type SubscriptionObj = {
  __typename?: 'SubscriptionObj';
  id?: Maybe<Scalars['String']>;
  itemId?: Maybe<Scalars['String']>;
  chargeType?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type SubscriptionPeriod = {
  __typename?: 'SubscriptionPeriod';
  startTimestamp?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Scalars['String']>;
  chargeQuantities?: Maybe<ChargeQuantity>;
  trial?: Maybe<Trial>;
};

/**
 * @deprecated
 */
export type Trial = {
  __typename?: 'TrialDetails';
  startTimestamp?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export enum SubscriptionScheduleAction {
  UPDATE = 'UPDATE',
  CANCEL = 'CANCEL',
  TRANSFER = 'TRANSFER',
  UPDATE_CANCEL = 'UPDATE_CANCEL',
  UPDATE_TRANSFER = 'UPDATE_TRANSFER',
}

/**
 * @deprecated
 */
export type SubscriptionTimeStamps = {
  __typename?: 'SubscriptionTimeStamps';
  firstStartTimestamp?: Maybe<Scalars['String']>;
  lastEndTimestamp?: Maybe<Scalars['String']>;
  firstTrialStartTimestamp?: Maybe<Scalars['String']>;
  lastTrialEndTimestamp?: Maybe<Scalars['String']>;
};

/**
 * Synthetic pricing plans may exist on offerings to provide discounts based on the customer (academic, open source, etc)
 * @deprecated
 */
export type SyntheticPricingPlan = {
  __typename?: 'SyntheticPricingPlan';
  type: Scalars['String'];
  status: Scalars['String'];
  discountPercentage: Scalars['Float'];
};

/**
 * @deprecated
 */
export type TaxRate = {
  __typename?: 'TaxRate';
  displayName?: Maybe<Scalars['String']>;
  isoCountryCode?: Maybe<Scalars['String']>;
  taxIdLabel?: Maybe<Scalars['String']>;
  taxType?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type CustomerBalancesRecord = {
  __typename?: 'CustomerBalancesRecord';
  usd?: Maybe<Scalars['Float']>;
};

/**
 * A container that groups together transaction-related entities. It is aimed at
 * helping a purchasing person (a Billing Admin) organize their transactions with
 * Atlassian. See more: [CCP Glossary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 * @deprecated
 */
export type TransactionAccount = {
  __typename?: 'TransactionAccount';
  id: Scalars['ID'];
  billToParty?: Maybe<CommerceAddress>;
  displayName?: Maybe<Scalars['String']>;
  partnerLevel?: Maybe<Scalars['String']>;
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  billingAdmins?: Maybe<BillingAdminConnection>;
  transactionAccountNumber?: Maybe<Scalars['String']>;
  availableInvoiceGroups?: Maybe<InvoiceGroupConnection>;
  availableShipToParties?: Maybe<CommerceAddressConnection>;
  availablePaymentMethods?: Maybe<PaymentMethodConnection>;
  billToPartyPricingEligibilty?: Maybe<Scalars['String']>;
  isPartner?: Maybe<Scalars['Boolean']>;
  products?: Maybe<TransactionAccountProductConnection>;
  status?: Maybe<Scalars['String']>;
  customerBalances?: Maybe<CustomerBalancesRecord>;
};

/**
 * A container that groups together transaction-related entities. It is aimed at
 * helping a purchasing person (a Billing Admin) organize their transactions with
 * Atlassian. See more: [CCP Glossary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 * @deprecated
 */
export type TransactionAccountBillingAdminsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * A container that groups together transaction-related entities. It is aimed at
 * helping a purchasing person (a Billing Admin) organize their transactions with
 * Atlassian. See more: [CCP Glossary](https://hello.atlassian.net/wiki/spaces/tintin/pages/553197746/Tintin%3A+CCP+Glossary)
 * @deprecated
 */
export type TransactionAccountProductsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * @deprecated
 */
export type TransactionAccountConnection = Connection & {
  __typename?: 'TransactionAccountConnection';
  totalCount?: Maybe<Scalars['Int']>;
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<TransactionAccountEdge>>>;
  nodes?: Maybe<Array<Maybe<TransactionAccount>>>;
};

/**
 * @deprecated
 */
export type TransactionAccountEdge = Edge & {
  __typename?: 'TransactionAccountEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: TransactionAccount;
};

/**
 * @deprecated
 */
export type TransactionAccountProduct = {
  __typename?: 'TransactionAccountProduct';
  billingFrequency?: Maybe<Scalars['String']>;
  entitlementNumber?: Maybe<Scalars['String']>;
  transactionAccountNumber?: Maybe<Scalars['String']>;
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  baseProduct?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type TransactionAccountProductConnection = Connection & {
  __typename?: 'TransactionAccountProductConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges?: Maybe<Array<Maybe<TransactionAccountProductEdge>>>;
  nodes?: Maybe<Array<Maybe<TransactionAccountProduct>>>;
};

/**
 * @deprecated
 */
export type TransactionAccountProductEdge = Edge & {
  __typename?: 'TransactionAccountProductEdge';
  cursor?: Maybe<Scalars['ID']>;
  node: TransactionAccountProduct;
};

/**
 * @deprecated
 */
export type Trello = Entitlement & {
  __typename?: 'Trello';
  baseProduct: Scalars['String'];
  billingFrequency?: Maybe<Scalars['String']>;
  billingGroupId?: Maybe<Scalars['String']>;
  billingStatus?: Maybe<Scalars['String']>;
  contacts: ContactConnection;
  emails: EmailConnection;
  firstPeriodEndDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latestPeriodEndDate?: Maybe<Scalars['String']>;
  latestPeriodStartDate?: Maybe<Scalars['String']>;
  offering?: Maybe<Offering>;
  plan?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  pricingPlan?: Maybe<PricingPlan>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  renewalAction?: Maybe<Scalars['String']>;
  supportIssues: SupportIssuesConnection;
  trFindLink: Scalars['String'];
};

/**
 * @deprecated
 */
export type TrelloContactsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * @deprecated
 */
export type TrelloEmailsArgs = {
  searchOptions?: Maybe<ConnectionSearchOptions>;
};

/**
 * @deprecated
 */
export type TrialPromotionDetails = {
  __typename?: 'TrialPromotionDetails';
  totalTrialCount?: Maybe<Scalars['Int']>;
  totalTrialDays?: Maybe<Scalars['Int']>;
};

/**
 * @deprecated
 */
export type User = {
  __typename?: 'User';
  id: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  primaryEmail?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<UserRole>>>;
  lastActive?: Maybe<Scalars['String']>;
  atlassianAccountId?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type UserConnection = Connection & {
  __typename?: 'UserConnection';
  totalCount?: Maybe<Scalars['Int']>;
  pageInfo?: Maybe<PageInfo>;
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  nodes?: Maybe<Array<Maybe<User>>>;
};

/**
 * @deprecated
 */
export type UserEdge = Edge & {
  __typename?: 'UserEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<User>;
};

/**
 * security profile of the logged in user
 * @deprecated
 */
export type UserProfile = {
  __typename?: 'UserProfile';
  userId: Scalars['String'];
  atlassianAccountId: Scalars['String'];
  avatarUrl?: Maybe<Scalars['String']>;
  hasValidBitbucketLink: Scalars['Boolean'];
  roles: Array<Maybe<Role>>;
  permissions: Array<Maybe<Permission>>;
  featureFlags: Scalars['JSON'];
  xsrfToken?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export enum UserRole {
  USER = 'USER',
  SITE_ADMIN = 'SITE_ADMIN',
}

/**
 * @deprecated
 */
export type ValidOfferings = {
  __typename?: 'ValidOfferings';
  key?: Maybe<Scalars['String']>;
  offeringKey?: Maybe<Scalars['String']>;
  offeringName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type FetchPortalAppQueryVariables = Exact<{
  app: Scalars['String'];
}>;

/**
 * @deprecated
 */
export type FetchPortalAppQuery = { __typename?: 'Query' } & {
  application?: Maybe<
    { __typename?: 'Application' } & {
      portalApp?: Maybe<{ __typename?: 'PortalApp' } & Pick<PortalApp, 'name' | 'appId' | 'url' | 'enabled'>>;
    }
  >;
};

/**
 * @deprecated
 */
export type ScheduledChangesForScheduledChangesTabFragment = { __typename?: 'ScheduledChanges' } & Pick<
  ScheduledChanges,
  'nextChangeTimestamp' | 'subscriptionScheduleAction' | 'scheduledBillingInvoiceGroupId'
> & {
    offering?: Maybe<{ __typename?: 'Offering' } & OfferingFieldsToCompareFragment>;
    pricingPlan?: Maybe<{ __typename?: 'PricingPlan' } & PricingPlanFieldsToCompareFragment>;
    promotions?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Promotion' } & Pick<
            Promotion,
            'id' | 'status' | 'rule' | 'title' | 'pricingType' | 'cycleInterval'
          > & {
              benefits?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'Benefit' } & Pick<
                      Benefit,
                      'value' | 'type' | 'benefitType' | 'scale' | 'subBenefitType'
                    >
                  >
                >
              >;
              promotionWindow?: Maybe<
                { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'startTime' | 'endTime'>
              >;
            }
        >
      >
    >;
  };

type CurrentStateForScheduledChangesTab_Statuspage_Fragment = { __typename?: 'Statuspage' } & {
  offering?: Maybe<{ __typename?: 'Offering' } & OfferingFieldsToCompareFragment>;
  pricingPlan?: Maybe<{ __typename?: 'PricingPlan' } & PricingPlanFieldsToCompareFragment>;
};

type CurrentStateForScheduledChangesTab_Trello_Fragment = { __typename?: 'Trello' } & {
  offering?: Maybe<{ __typename?: 'Offering' } & OfferingFieldsToCompareFragment>;
  pricingPlan?: Maybe<{ __typename?: 'PricingPlan' } & PricingPlanFieldsToCompareFragment>;
};

/**
 * @deprecated
 */
export type CurrentStateForScheduledChangesTabFragment =
  | CurrentStateForScheduledChangesTab_Statuspage_Fragment
  | CurrentStateForScheduledChangesTab_Trello_Fragment;

/**
 * @deprecated
 */
export type OfferingFieldsToCompareFragment = { __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'>;

/**
 * @deprecated
 */
export type PricingPlanFieldsToCompareFragment = { __typename?: 'PricingPlan' } & Pick<
  PricingPlan,
  'type' | 'billingFrequency'
>;

type SubscribeToAddOnsFormData_Statuspage_Fragment = { __typename?: 'Statuspage' } & {
  offering?: Maybe<
    { __typename?: 'Offering' } & {
      availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
    }
  >;
};

type SubscribeToAddOnsFormData_Trello_Fragment = { __typename?: 'Trello' } & {
  offering?: Maybe<
    { __typename?: 'Offering' } & {
      availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
    }
  >;
};

/**
 * @deprecated
 */
export type SubscribeToAddOnsFormDataFragment =
  | SubscribeToAddOnsFormData_Statuspage_Fragment
  | SubscribeToAddOnsFormData_Trello_Fragment;

/**
 * @deprecated
 */
export type FetchAnnouncementsQueryVariables = Exact<{ [key: string]: never }>;

/**
 * @deprecated
 */
export type FetchAnnouncementsQuery = { __typename?: 'Query' } & {
  application?: Maybe<
    { __typename?: 'Application' } & {
      announcements?: Maybe<
        { __typename?: 'AnnouncementConnection' } & {
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'Announcement' } & Pick<
                  Announcement,
                  'title' | 'isUnseen' | 'url' | 'description' | 'expiryDate'
                > & {
                    previewThumbnail?: Maybe<{ __typename?: 'PreviewThumbnail' } & Pick<PreviewThumbnail, 'link'>>;
                    meta?: Maybe<
                      { __typename?: 'AnnouncementMeta' } & Pick<AnnouncementMeta, 'createdAt' | 'updatedAt'>
                    >;
                  }
              >
            >
          >;
        }
      >;
    }
  >;
};

type NavigationItemsFragment_NavigationGroup_Fragment = { __typename: 'NavigationGroup' } & Pick<
  NavigationGroup,
  'name'
> & {
    links?: Maybe<Array<Maybe<{ __typename?: 'NavigationLink' } & Pick<NavigationLink, 'name' | 'url' | 'iconUrl'>>>>;
  };

type NavigationItemsFragment_NavigationLink_Fragment = { __typename: 'NavigationLink' } & Pick<
  NavigationLink,
  'name' | 'url' | 'iconUrl'
>;

/**
 * @deprecated
 */
export type NavigationItemsFragmentFragment =
  | NavigationItemsFragment_NavigationGroup_Fragment
  | NavigationItemsFragment_NavigationLink_Fragment;

/**
 * @deprecated
 */
export type FetchApplicationQueryVariables = Exact<{
  id: Scalars['String'];
}>;

/**
 * @deprecated
 */
export type FetchApplicationQuery = { __typename?: 'Query' } & {
  application?: Maybe<
    { __typename?: 'Application' } & Pick<Application, 'id' | 'name' | 'iconUrl'> & {
        helpNavigation?: Maybe<
          Array<
            Maybe<
              | ({ __typename: 'NavigationGroup' } & NavigationItemsFragment_NavigationGroup_Fragment)
              | ({ __typename: 'NavigationLink' } & NavigationItemsFragment_NavigationLink_Fragment)
            >
          >
        >;
        appSwitcherNavigation?: Maybe<
          Array<
            Maybe<
              | ({ __typename: 'NavigationGroup' } & NavigationItemsFragment_NavigationGroup_Fragment)
              | ({ __typename: 'NavigationLink' } & NavigationItemsFragment_NavigationLink_Fragment)
            >
          >
        >;
      }
  >;
};

/**
 * @deprecated
 */
export type FetchBannerQueryVariables = Exact<{ [key: string]: never }>;

/**
 * @deprecated
 */
export type FetchBannerQuery = { __typename?: 'Query' } & {
  application?: Maybe<
    { __typename?: 'Application' } & {
      banner?: Maybe<
        { __typename?: 'Banner' } & Pick<
          Banner,
          'title' | 'bannerAppearance' | 'message' | 'incidentTicketUrl' | 'dismissalExpiration'
        >
      >;
    }
  >;
};

/**
 * @deprecated
 */
export type FetchFeatureFlagQueryVariables = Exact<{
  flagKey: Scalars['String'];
  targetingProperties?: Maybe<Scalars['JSON']>;
}>;

/**
 * @deprecated
 */
export type FetchFeatureFlagQuery = { __typename?: 'Query' } & {
  application?: Maybe<
    { __typename?: 'Application' } & {
      featureFlag?: Maybe<{ __typename?: 'FeatureFlag' } & Pick<FeatureFlag, 'flagKey' | 'isEnabled'>>;
    }
  >;
};

/**
 * @deprecated
 */
export type FetchUserProfileQueryVariables = Exact<{ [key: string]: never }>;

/**
 * @deprecated
 */
export type FetchUserProfileQuery = { __typename?: 'Query' } & {
  me?: Maybe<
    { __typename?: 'UserProfile' } & Pick<
      UserProfile,
      | 'userId'
      | 'atlassianAccountId'
      | 'avatarUrl'
      | 'hasValidBitbucketLink'
      | 'roles'
      | 'permissions'
      | 'featureFlags'
      | 'xsrfToken'
    >
  >;
};

/**
 * @deprecated
 */
export type FetchAvailableCountriesQueryVariables = Exact<{ [key: string]: never }>;

/**
 * @deprecated
 */
export type FetchAvailableCountriesQuery = { __typename?: 'Query' } & {
  availableCountries: { __typename?: 'BillingCountryConnection' } & Pick<BillingCountryConnection, 'totalCount'> & {
      nodes: Array<Maybe<{ __typename?: 'BillingCountry' } & Pick<BillingCountry, 'isoCode' | 'name'>>>;
    };
};

/**
 * @deprecated
 */
export type FetchAvailableStatesForCountriesQueryVariables = Exact<{
  isoCode?: Maybe<Scalars['String']>;
}>;

/**
 * @deprecated
 */
export type FetchAvailableStatesForCountriesQuery = { __typename?: 'Query' } & {
  availableStatesForCountry: { __typename?: 'BillingCountryStateConnection' } & Pick<
    BillingCountryStateConnection,
    'totalCount'
  > & { nodes: Array<Maybe<{ __typename?: 'BillingCountryState' } & Pick<BillingCountryState, 'isoCode' | 'name'>>> };
};

/**
 * @deprecated
 */
export type FetchDirectMatchForSearchQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
}>;

/**
 * @deprecated
 */
export type FetchDirectMatchForSearchQuery = { __typename?: 'Query' } & {
  searchForDirectMatch?: Maybe<
    { __typename?: 'DirectMatch' } & Pick<DirectMatch, 'entity' | 'identifier' | 'parentEntity' | 'parentIdentifier'>
  >;
};

/**
 * @deprecated
 */
export type FetchOppsForContactspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchOppsForContactspageQuery = { __typename?: 'Query' } & {
  personByEmailAddress?: Maybe<
    { __typename?: 'Person' } & Pick<Person, 'emailAddress'> & {
        opportunities: { __typename?: 'OpportunityConnection' } & Pick<OpportunityConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Opportunity' } & Pick<
                    Opportunity,
                    'id' | 'accountName' | 'saleType' | 'amount' | 'netOrderAmount' | 'stageName' | 'ownerName'
                  > & {
                      opportunityLineItems?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'OpportunityLineItem' } & Pick<OpportunityLineItem, 'inventoryProductName'>
                          >
                        >
                      >;
                      shipTo?: Maybe<
                        { __typename?: 'CommerceAddress' } & Pick<
                          CommerceAddress,
                          'addressLine1' | 'addressLine2' | 'city' | 'country' | 'postcode'
                        >
                      >;
                      billTo?: Maybe<
                        { __typename?: 'CommerceAddress' } & Pick<
                          CommerceAddress,
                          'addressLine1' | 'addressLine2' | 'city' | 'country' | 'postcode' | 'phone'
                        >
                      >;
                    }
                >
              >
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          };
      }
  >;
};

/**
 * @deprecated
 */
export type OpsgenieSummaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

/**
 * @deprecated
 */
export type OpsgenieSummaryQuery = { __typename?: 'Query' } & {
  opsgenie?: Maybe<
    { __typename?: 'Opsgenie' } & Pick<
      Opsgenie,
      | 'baseProduct'
      | 'id'
      | 'plan'
      | 'renewalAction'
      | 'billingFrequency'
      | 'latestPeriodEndDate'
      | 'latestPeriodStartDate'
      | 'platform'
      | 'productId'
      | 'billingStatus'
      | 'productName'
    >
  >;
};

/**
 * @deprecated
 */
export type FetchAddOnsForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchAddOnsForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      addOns?: Maybe<
        { __typename?: 'AddOnConnection' } & Pick<AddOnConnection, 'totalCount'> & {
            edges?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'AddOnEdge' } & {
                    node?: Maybe<
                      { __typename?: 'AddOn' } & Pick<
                        AddOn,
                        | 'entitlementNumber'
                        | 'dateAdded'
                        | 'units'
                        | 'name'
                        | 'nextBillDate'
                        | 'dateRemoved'
                        | 'dateLastBilled'
                        | 'billingStatus'
                      >
                    >;
                  }
                >
              >
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchAddOnsParentEntitlementQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

/**
 * @deprecated
 */
export type FetchAddOnsParentEntitlementQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<
    Statuspage,
    | 'id'
    | 'billingCycle'
    | 'billingStatus'
    | 'entitlementNumber'
    | 'latestPeriodEndDate'
    | 'latestPeriodStartDate'
    | 'offeringId'
    | 'productName'
    | 'sourceSystem'
    | 'plan'
  > & { offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'>> };
};

/**
 * @deprecated
 */
export type FetchAvailableAddOnsForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

/**
 * @deprecated
 */
export type FetchAvailableAddOnsForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & {
    offering?: Maybe<
      { __typename?: 'Offering' } & {
        availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
      }
    >;
  };
};

/**
 * @deprecated
 */
export type FetchAvailableOfferingsForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

/**
 * @deprecated
 */
export type FetchAvailableOfferingsForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      offering?: Maybe<
        { __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'> & {
            availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
            availableSyntheticPricingPlans?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'SyntheticPricingPlan' } & Pick<
                    SyntheticPricingPlan,
                    'type' | 'status' | 'discountPercentage'
                  >
                >
              >
            >;
          }
      >;
      addOns?: Maybe<
        { __typename?: 'AddOnConnection' } & {
          nodes?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name' | 'units'>>>>;
        }
      >;
      availableOfferings?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Offering' } & Pick<Offering, 'id' | 'name' | 'productKey' | 'level'> & {
                availableAddOns?: Maybe<Array<Maybe<{ __typename?: 'AddOn' } & Pick<AddOn, 'offeringId' | 'name'>>>>;
                availableSyntheticPricingPlans?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'SyntheticPricingPlan' } & Pick<
                        SyntheticPricingPlan,
                        'type' | 'status' | 'discountPercentage'
                      >
                    >
                  >
                >;
              }
          >
        >
      >;
      validOfferings?: Maybe<
        Array<
          Maybe<
            { __typename?: 'ValidOfferings' } & Pick<ValidOfferings, 'key' | 'offeringKey' | 'offeringName' | 'status'>
          >
        >
      >;
    };
};
/**
 * @deprecated
 */
export type FetchInvoicesForInvoiceGroupPageQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchInvoicesForInvoiceGroupPageQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
        invoices: { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    | 'id'
                    | 'invoiceNumber'
                    | 'sourceSystem'
                    | 'paymentMethod'
                    | 'creditCardMaskedNumber'
                    | 'dueDate'
                    | 'createdDate'
                    | 'grandTotal'
                    | 'paymentCurrency'
                    | 'purchaseOrderNumber'
                  > & {
                      refunds?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'Refunds' } & Pick<
                              Refunds,
                              'id' | 'type' | 'creditNoteNumber' | 'sourceSystem' | 'total' | 'currency' | 'status'
                            >
                          >
                        >
                      >;
                    }
                >
              >
            >;
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
          };
      }
  >;
};

/**
 * @deprecated
 */
export type FetchInvoicesForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchInvoicesForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      invoices: { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'Invoice' } & Pick<
                  Invoice,
                  | 'id'
                  | 'invoiceNumber'
                  | 'sourceSystem'
                  | 'paymentMethod'
                  | 'dueDate'
                  | 'createdDate'
                  | 'total'
                  | 'paymentCurrency'
                > & {
                    refunds?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'Refunds' } & Pick<
                            Refunds,
                            'id' | 'type' | 'creditNoteNumber' | 'sourceSystem' | 'total' | 'currency' | 'status'
                          >
                        >
                      >
                    >;
                  } & {
                    creditCard?: Maybe<
                      { __typename?: 'CreditCard' } & Pick<
                        CreditCardDetails,
                        'last4Numbers' | 'expirationMonth' | 'expirationYear' | 'brand'
                      >
                    >;
                  }
              >
            >
          >;
          pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
        };
    };
};

/**
 * @deprecated
 */
export type FetchInvoicesForContactQueryVariables = Exact<{
  email?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchInvoicesForContactQuery = { __typename?: 'Query' } & {
  fetchContact: { __typename?: 'Contact' } & Pick<Contact, 'email'> & {
      invoices: { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
          nodes?: Maybe<
            Array<
              Maybe<
                { __typename?: 'Invoice' } & Pick<
                  Invoice,
                  | 'id'
                  | 'invoiceNumber'
                  | 'sourceSystem'
                  | 'paymentMethod'
                  | 'dueDate'
                  | 'createdDate'
                  | 'total'
                  | 'paymentCurrency'
                > & {
                    refunds?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: 'Refunds' } & Pick<
                            Refunds,
                            'id' | 'creditNoteNumber' | 'sourceSystem' | 'total' | 'currency' | 'status'
                          >
                        >
                      >
                    >;
                  }
              >
            >
          >;
          pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
        };
    };
};

/**
 * @deprecated
 */
export type FetchEmailForContactQueryVariables = Exact<{
  email?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchEmailsForContactQuery = { __typename?: 'Query' } & {
  fetchContact: { __typename?: 'Contact' } & Pick<Contact, 'email'> & {
      emails?: Maybe<
        { __typename?: 'EmailConnection' } & Pick<EmailConnection, 'totalCount'> & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            edges?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'EmailEdge' } & {
                    node?: Maybe<{ __typename?: 'Email' }> &
                      Pick<Email, 'subject' | 'size' | 'id' | 'html' | 'text' | 'date'> & {
                        to?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address'>>>>;
                        from?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address'>>>>;
                      } & {
                        attachments?: Maybe<
                          Array<
                            Maybe<
                              { __typename?: 'Attachment' } & Pick<
                                Attachment,
                                | 'id'
                                | 'checksum'
                                | 'contentType'
                                | 'contentDisposition'
                                | 'contentId'
                                | 'filename'
                                | 'self'
                                | 'size'
                              >
                            >
                          >
                        >;
                      };
                  }
                >
              >
            >;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchOrdersForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchOrdersForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      orders?: Maybe<
        { __typename?: 'OrderConnection' } & Pick<OrderConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'Order' } & Pick<Order, 'id' | 'orderNumber' | 'created' | 'contextSubject'> & {
                    billingGroup?: Maybe<
                      { __typename?: 'OrderBillingGroup' } & Pick<OrderBillingGroup, 'billingGroupId'>
                    >;
                    invoiceGroup?: Maybe<
                      { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'name'> & {
                          shipToParty?: Maybe<
                            { __typename?: 'CommerceAddress' } & Pick<
                              CommerceAddress,
                              'id' | 'name' | 'addressLine1' | 'addressLine2' | 'city' | 'country' | 'postcode'
                            >
                          >;
                          defaultPaymentMethod?: Maybe<
                            | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type'> & {
                                  card?: Maybe<
                                    { __typename?: 'CreditCardDetails' } & Pick<
                                      CreditCardDetails,
                                      'last4Numbers' | 'expirationMonth' | 'expirationYear' | 'brand'
                                    >
                                  >;
                                })
                            | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type'> & {
                                  terms?: Maybe<
                                    { __typename?: 'PaymentOnTermsDetails' } & Pick<
                                      PaymentOnTermsDetails,
                                      'invoiceDueDays'
                                    >
                                  >;
                                })
                          >;
                        }
                    >;
                    metadata?: Maybe<{ __typename?: 'OrderMetadata' } & Pick<OrderMetadata, 'supportTicketNumber'>>;
                    orderLineItems?: Maybe<
                      { __typename?: 'OrderLineItemConnection' } & {
                        nodes: Array<
                          Maybe<
                            { __typename?: 'OrderLineItem' } & Pick<
                              OrderLineItem,
                              | 'lineItemId'
                              | 'entitlementId'
                              | 'parentEntitlementId'
                              | 'entitlementNumber'
                              | 'pricingPlanId'
                              | 'status'
                              | 'type'
                              | 'quantity'
                              | 'offeringId'
                              | 'promotionCodes'
                              | 'orderTransitionType'
                              | 'salesTransitionType'
                            > & {
                                pricingPlan?: Maybe<
                                  { __typename?: 'PricingPlan' } & Pick<PricingPlan, 'type' | 'billingFrequency'>
                                >;
                                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'>>;
                                promotions?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'Promotion' } & Pick<Promotion, 'id' | 'title' | 'status'> & {
                                          benefits?: Maybe<
                                            Array<
                                              Maybe<
                                                { __typename?: 'Benefit' } & Pick<
                                                  Benefit,
                                                  'subBenefitType' | 'value' | 'iterations' | 'duration' | 'benefitType'
                                                >
                                              >
                                            >
                                          >;
                                          promotionWindow?: Maybe<
                                            { __typename?: 'PromotionWindow' } & Pick<
                                              PromotionWindow,
                                              'endTime' | 'startTime'
                                            >
                                          >;
                                        }
                                    >
                                  >
                                >;
                              }
                          >
                        >;
                      }
                    >;
                  }
              >
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};
/**
 * @deprecated
 */
export type DateRange = {
  from: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

/**
 * @deprecated
 */
export type AuditTrailQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  dateFilter?: Maybe<DateRange>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type AuditTrailQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      auditNotes?: Maybe<
        { __typename?: 'AuditNoteConnection' } & Pick<AuditNoteConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<{ __typename?: 'AuditNote' } & Pick<AuditNote, 'body' | 'author' | 'created' | 'contactKey'>>
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchEmailsForStatuspagePageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchEmailsForStatuspagePageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      emails?: Maybe<
        { __typename?: 'EmailConnection' } & Pick<EmailConnection, 'totalCount'> & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            edges?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'EmailEdge' } & {
                    node: { __typename?: 'Email' } & Pick<
                      Email,
                      'subject' | 'size' | 'id' | 'html' | 'text' | 'date'
                    > & {
                        to?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address'>>>>;
                        from?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address'>>>>;
                      };
                  }
                >
              >
            >;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchOrdersForRewindOnStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

/**
 * @deprecated
 */
export type FetchOrdersForRewindOnStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      ordersForRewind?: Maybe<
        { __typename?: 'OrderConnection' } & Pick<OrderConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'Order' } & Pick<Order, 'id' | 'orderNumber' | 'created' | 'contextSubject'> & {
                    billingGroup?: Maybe<
                      { __typename?: 'OrderBillingGroup' } & Pick<OrderBillingGroup, 'billingGroupId'>
                    >;
                    orderLineItems?: Maybe<
                      { __typename?: 'OrderLineItemConnection' } & {
                        nodes: Array<
                          Maybe<
                            { __typename?: 'OrderLineItem' } & Pick<
                              OrderLineItem,
                              | 'lineItemId'
                              | 'entitlementId'
                              | 'parentEntitlementId'
                              | 'entitlementNumber'
                              | 'pricingPlanId'
                              | 'status'
                              | 'type'
                              | 'quantity'
                              | 'promotionCodes'
                              | 'orderTransitionType'
                              | 'salesTransitionType'
                            > & {
                                pricingPlan?: Maybe<
                                  { __typename?: 'PricingPlan' } & Pick<PricingPlan, 'type' | 'billingFrequency'>
                                >;
                                offering?: Maybe<{ __typename?: 'Offering' } & Pick<Offering, 'name' | 'id'>>;
                                promotions?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'Promotion' } & Pick<
                                        Promotion,
                                        | 'id'
                                        | 'title'
                                        | 'status'
                                        | 'cycleInterval'
                                        | 'pricingType'
                                        | 'isPromotionCustomisable'
                                      > & {
                                          benefits?: Maybe<
                                            Array<
                                              Maybe<
                                                { __typename?: 'Benefit' } & Pick<
                                                  Benefit,
                                                  | 'benefitType'
                                                  | 'subBenefitType'
                                                  | 'iterations'
                                                  | 'value'
                                                  | 'scale'
                                                  | 'type'
                                                  | 'duration'
                                                > & {
                                                    customisable?: Maybe<
                                                      { __typename?: 'BenefitCustomisableObj' } & Pick<
                                                        BenefitCustomisableObj,
                                                        'duration'
                                                      > & {
                                                          value?: Maybe<
                                                            { __typename?: 'BenefitCustomisableValue' } & Pick<
                                                              BenefitCustomisableValue,
                                                              'type' | 'lowerBound' | 'upperBound'
                                                            >
                                                          >;
                                                          iterations?: Maybe<
                                                            { __typename?: 'BenefitCustomisableValue' } & Pick<
                                                              BenefitCustomisableValue,
                                                              'type' | 'lowerBound' | 'upperBound'
                                                            >
                                                          >;
                                                        }
                                                    >;
                                                  }
                                              >
                                            >
                                          >;
                                          promotionWindow?: Maybe<
                                            { __typename?: 'PromotionWindow' } & Pick<
                                              PromotionWindow,
                                              'endTime' | 'startTime'
                                            >
                                          >;
                                          eligibilityRules?: Maybe<
                                            { __typename?: 'EligibilityRule' } & Pick<
                                              EligibilityRule,
                                              | 'products'
                                              | 'cycleInterval'
                                              | 'pricingType'
                                              | 'partnerType'
                                              | 'partnerTier'
                                              | 'saleTransitionType'
                                              | 'currency'
                                            >
                                          >;
                                          applicationReason?: Maybe<
                                            { __typename?: 'PromotionReason' } & Pick<
                                              PromotionReason,
                                              'id' | 'readableName'
                                            > & {
                                                customisable?: Maybe<
                                                  { __typename?: 'PromotionReasonCustomisable' } & {
                                                    id?: Maybe<
                                                      { __typename?: 'PromotionReasonListObj' } & Pick<
                                                        PromotionReasonListObj,
                                                        'type'
                                                      > & {
                                                          anyOf?: Maybe<
                                                            Array<
                                                              Maybe<
                                                                { __typename?: 'ReasonCustomisableObj' } & Pick<
                                                                  ReasonCustomisableObj,
                                                                  'readableName' | 'id'
                                                                >
                                                              >
                                                            >
                                                          >;
                                                        }
                                                    >;
                                                  }
                                                >;
                                              }
                                          >;
                                        }
                                    >
                                  >
                                >;
                              }
                          >
                        >;
                      }
                    >;
                  }
              >
            >;
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchStatuspageDetailsQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

/**
 * @deprecated
 */
export type FetchStatuspageDetailsQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<
    Statuspage,
    | 'billingStatus'
    | 'cloudSiteHostname'
    | 'cloudSiteCustomHostname'
    | 'cloudSiteId'
    | 'cloudSiteSen'
    | 'entitlementNumber'
    | 'updatePaymentMethodLink'
    | 'hasPendingInvoices'
    | 'id'
    | 'latestPeriodEndDate'
    | 'latestPeriodStartDate'
    | 'transactionAccountId'
    | 'billingGroupId'
    | 'licenseLevel'
    | 'offeringId'
    | 'version'
    | 'edition'
    | 'parentSen'
    | 'parentCloudSiteName'
    | 'platform'
    | 'productId'
    | 'productName'
    | 'baseProduct'
    | 'renewalAction'
    | 'sourceSystem'
    | 'plan'
    | 'subscriptionId'
    | 'unitCount'
    | 'activeSubscriptionBillingGroupId'
    | 'provisioningStatus'
  > & { billingFrequency: Statuspage['billingCycle'] } & {
      addOns?: Maybe<{ __typename?: 'AddOnConnection' } & Pick<AddOnConnection, 'totalCount'>>;
      offering?: Maybe<
        { __typename?: 'Offering' } & Pick<Offering, 'id' | 'name'> & {
            availableSyntheticPricingPlans?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'SyntheticPricingPlan' } & Pick<
                    SyntheticPricingPlan,
                    'type' | 'status' | 'discountPercentage'
                  >
                >
              >
            >;
          }
      >;
      promotions?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Promotion' } & Pick<
              Promotion,
              'id' | 'title' | 'status' | 'cycleInterval' | 'pricingType'
            > & {
                benefits?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'Benefit' } & Pick<
                        Benefit,
                        'benefitType' | 'subBenefitType' | 'iterations' | 'value' | 'scale' | 'type'
                      >
                    >
                  >
                >;
                promotionWindow?: Maybe<
                  { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'endTime' | 'startTime'>
                >;
                eligibilityRules?: Maybe<
                  { __typename?: 'EligibilityRule' } & Pick<
                    EligibilityRule,
                    | 'products'
                    | 'cycleInterval'
                    | 'pricingType'
                    | 'partnerType'
                    | 'partnerTier'
                    | 'saleTransitionType'
                    | 'currency'
                  >
                >;
              }
          >
        >
      >;
      availablePromotions?: Maybe<
        Array<
          Maybe<
            { __typename?: 'Promotion' } & Pick<
              Promotion,
              'id' | 'title' | 'status' | 'cycleInterval' | 'pricingType'
            > & {
                benefits?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'Benefit' } & Pick<
                        Benefit,
                        'benefitType' | 'subBenefitType' | 'iterations' | 'value' | 'scale' | 'type'
                      >
                    >
                  >
                >;
                promotionWindow?: Maybe<
                  { __typename?: 'PromotionWindow' } & Pick<PromotionWindow, 'endTime' | 'startTime'>
                >;
                eligibilityRules?: Maybe<
                  { __typename?: 'EligibilityRule' } & Pick<
                    EligibilityRule,
                    | 'products'
                    | 'cycleInterval'
                    | 'pricingType'
                    | 'partnerType'
                    | 'partnerTier'
                    | 'saleTransitionType'
                    | 'currency'
                  >
                >;
              }
          >
        >
      >;
      trialPromotionDetails?: Maybe<
        { __typename?: 'TrialPromotionDetails' } & Pick<TrialPromotionDetails, 'totalTrialDays' | 'totalTrialCount'>
      >;
      subscriptionTimestamps?: Maybe<
        { __typename?: 'SubscriptionTimeStamps' } & Pick<
          SubscriptionTimeStamps,
          'firstStartTimestamp' | 'lastEndTimestamp' | 'firstTrialStartTimestamp' | 'lastTrialEndTimestamp'
        >
      >;
      scheduledChanges?: Maybe<{ __typename?: 'ScheduledChanges' } & ScheduledChangesForScheduledChangesTabFragment>;
    } & SubscribeToAddOnsFormData_Statuspage_Fragment &
    CurrentStateForScheduledChangesTab_Statuspage_Fragment;
};

/**
 * @deprecated
 */
export type FetchSiteAdminsForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

/**
 * @deprecated
 */
export type FetchSiteAdminsForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      siteAdmins?: Maybe<
        { __typename?: 'SiteAdminConnection' } & Pick<SiteAdminConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'SiteAdmin' } & Pick<
                    SiteAdmin,
                    'displayName' | 'primaryEmail' | 'roles' | 'lastActive'
                  >
                >
              >
            >;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchSupportIssuesForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;

/**
 * @deprecated
 */
export type FetchSupportIssuesForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      supportIssues?: Maybe<
        { __typename?: 'SupportIssues' } & Pick<SupportIssues, 'totalHits'> & {
            supportIssues: Array<
              Maybe<
                { __typename?: 'SupportIssue' } & Pick<
                  SupportIssue,
                  'id' | 'issueKey' | 'summary' | 'status' | 'reporterEmailAddress' | 'updatedTimestamp'
                >
              >
            >;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchUsersForStatuspageQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchUsersForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      users?: Maybe<
        { __typename?: 'UserConnection' } & Pick<UserConnection, 'totalCount'> & {
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
            nodes?: Maybe<
              Array<
                Maybe<{ __typename?: 'User' } & Pick<User, 'displayName' | 'primaryEmail' | 'roles' | 'lastActive'>>
              >
            >;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchTransactionAccountForStatuspageQueryVariables = Exact<{
  entitlementId?: Maybe<Scalars['String']>;
}>;

/**
 * @deprecated
 */
export type FetchTransactionAccountForStatuspageQuery = { __typename?: 'Query' } & {
  statuspage: { __typename?: 'Statuspage' } & Pick<Statuspage, 'id'> & {
      transactionAccount?: Maybe<
        { __typename?: 'TransactionAccount' } & Pick<
          TransactionAccount,
          'id' | 'displayName' | 'partnerLevel' | 'transactionAccountNumber' | 'billToPartyPricingEligibilty'
        > & {
            availablePaymentMethods?: Maybe<
              { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'>
            >;
            billToParty?: Maybe<
              { __typename?: 'CommerceAddress' } & Pick<
                CommerceAddress,
                'name' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postcode' | 'taxId'
              >
            >;
            defaultPaymentMethod?: Maybe<
              | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'type'> & {
                    card?: Maybe<
                      { __typename?: 'CreditCardDetails' } & Pick<
                        CreditCardDetails,
                        'last4Numbers' | 'expirationMonth' | 'expirationYear' | 'brand'
                      >
                    >;
                  })
              | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'type'> & {
                    terms?: Maybe<
                      { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                    >;
                  })
            >;
            billingAdmins?: Maybe<
              { __typename?: 'BillingAdminConnection' } & {
                nodes?: Maybe<Array<Maybe<{ __typename?: 'BillingAdmin' } & Pick<BillingAdmin, 'email'>>>>;
              }
            >;
            availableInvoiceGroups?: Maybe<
              { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
                  nodes: Array<
                    Maybe<
                      { __typename?: 'InvoiceGroup' } & Pick<
                        InvoiceGroup,
                        'id' | 'name' | 'currency' | 'shipToPriceEligibility'
                      > & {
                          shipToParty?: Maybe<
                            { __typename?: 'CommerceAddress' } & Pick<
                              CommerceAddress,
                              | 'id'
                              | 'name'
                              | 'addressLine1'
                              | 'addressLine2'
                              | 'city'
                              | 'state'
                              | 'country'
                              | 'postcode'
                              | 'taxId'
                            >
                          >;
                          defaultPaymentMethod?: Maybe<
                            | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'type'> & {
                                  card?: Maybe<
                                    { __typename?: 'CreditCardDetails' } & Pick<
                                      CreditCardDetails,
                                      'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
                                    >
                                  >;
                                })
                            | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'type'> & {
                                  terms?: Maybe<
                                    { __typename?: 'PaymentOnTermsDetails' } & Pick<
                                      PaymentOnTermsDetails,
                                      'invoiceDueDays'
                                    >
                                  >;
                                })
                          >;
                        }
                    >
                  >;
                }
            >;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchEmailsForTrelloPageQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchEmailsForTrelloPageQuery = { __typename?: 'Query' } & {
  trello: { __typename?: 'Trello' } & Pick<Trello, 'id'> & {
      emails: { __typename?: 'EmailConnection' } & Pick<EmailConnection, 'totalCount'> & {
          pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
          edges?: Maybe<
            Array<
              Maybe<
                { __typename?: 'EmailEdge' } & {
                  node: { __typename?: 'Email' } & Pick<Email, 'subject' | 'size' | 'id' | 'html' | 'text' | 'date'> & {
                      to?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address'>>>>;
                      from?: Maybe<Array<Maybe<{ __typename?: 'EmailAddress' } & Pick<EmailAddress, 'address'>>>>;
                    };
                }
              >
            >
          >;
        };
    };
};

/**
 * @deprecated
 */
export type FetchPeopleForTrelloPageQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchPeopleForTrelloPageQuery = { __typename?: 'Query' } & {
  trello: { __typename?: 'Trello' } & Pick<Trello, 'id'> & {
      contacts: { __typename?: 'ContactConnection' } & Pick<ContactConnection, 'totalCount'> & {
          pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
          edges?: Maybe<
            Array<
              Maybe<
                { __typename?: 'ContactEdge' } & {
                  node?: Maybe<
                    { __typename?: 'Contact' } & Pick<Contact, 'email'> & { displayName: Contact['fullName'] }
                  >;
                }
              >
            >
          >;
        };
    };
};

/**
 * @deprecated
 */
export type FetchSupportIssuesForTrelloPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

/**
 * @deprecated
 */
export type FetchSupportIssuesForTrelloPageQuery = { __typename?: 'Query' } & {
  trello: { __typename?: 'Trello' } & Pick<Trello, 'id'> & {
      supportIssues: { __typename?: 'SupportIssuesConnection' } & Pick<SupportIssuesConnection, 'totalCount'> & {
          pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
          edges: Array<
            Maybe<
              { __typename?: 'SupportIssueEdge' } & {
                node?: Maybe<
                  { __typename?: 'SupportIssue' } & Pick<
                    SupportIssue,
                    'id' | 'issueKey' | 'summary' | 'status' | 'reporterEmailAddress' | 'updatedTimestamp'
                  >
                >;
              }
            >
          >;
        };
    };
};

/**
 * @deprecated
 */
export type TrelloPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

/**
 * @deprecated
 */
export type TrelloPageQuery = { __typename?: 'Query' } & {
  trello: { __typename?: 'Trello' } & Pick<
    Trello,
    | 'baseProduct'
    | 'id'
    | 'plan'
    | 'renewalAction'
    | 'billingFrequency'
    | 'latestPeriodEndDate'
    | 'latestPeriodStartDate'
    | 'platform'
    | 'productId'
    | 'billingStatus'
    | 'productName'
  >;
};

/**
 * @deprecated
 */
export type FetchAvailablePaymentMethodsForInvoiceGroupQueryVariables = Exact<{
  transactionAccountId: Scalars['ID'];
}>;

/**
 * @deprecated
 */
export type FetchAvailablePaymentMethodsForInvoiceGroupQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & {
    defaultPaymentMethod?: Maybe<
      | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type'> & {
            card?: Maybe<
              { __typename?: 'CreditCardDetails' } & Pick<
                CreditCardDetails,
                'last4Numbers' | 'expirationMonth' | 'expirationYear' | 'brand'
              >
            >;
          })
      | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type'> & {
            terms?: Maybe<{ __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>>;
          })
    >;
    availablePaymentMethods?: Maybe<
      { __typename?: 'PaymentMethodConnection' } & {
        nodes?: Maybe<
          Array<
            Maybe<
              | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type'> & {
                    card?: Maybe<
                      { __typename?: 'CreditCardDetails' } & Pick<
                        CreditCardDetails,
                        'last4Numbers' | 'expirationMonth' | 'expirationYear' | 'brand'
                      >
                    >;
                  })
              | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type'> & {
                    terms?: Maybe<
                      { __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>
                    >;
                  })
            >
          >
        >;
      }
    >;
  };
};

/**
 * @deprecated
 */
export type FetchInvoiceGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

/**
 * @deprecated
 */
export type FetchInvoiceGroupQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<
      InvoiceGroup,
      | 'id'
      | 'name'
      | 'currency'
      | 'updatePaymentMethodLink'
      | 'transactionAccountId'
      | 'transactionAccountNumber'
      | 'recipients'
    > & {
        shipToParty?: Maybe<
          { __typename?: 'CommerceAddress' } & Pick<
            CommerceAddress,
            | 'id'
            | 'name'
            | 'addressLine1'
            | 'addressLine2'
            | 'city'
            | 'state'
            | 'country'
            | 'postcode'
            | 'taxId'
            | 'shipToPriceEligibility'
            | 'taxExempt'
          >
        >;
        defaultPaymentMethod?: Maybe<
          | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'type' | 'default'>)
          | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'type' | 'default'>)
        >;
        transactionAccount?: Maybe<
          { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id' | 'displayName'>
        >;
        purchaseOrder?: Maybe<
          { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<InvoiceGroupPurchaseOrder, 'number' | 'oneTimeUse'>
        >;
      }
  >;
};

/**
 * @deprecated
 */
export type FetchProductsForInvoiceGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

/**
 * @deprecated
 */
export type FetchProductsForInvoiceGroupQuery = { __typename?: 'Query' } & {
  invoiceGroup?: Maybe<
    { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
        products?: Maybe<
          { __typename?: 'InvoiceGroupProductConnection' } & Pick<InvoiceGroupProductConnection, 'totalCount'> & {
              pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
              nodes?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'InvoiceGroupProduct' } & Pick<
                      InvoiceGroupProduct,
                      | 'billingFrequency'
                      | 'billingStatus'
                      | 'entitlementNumber'
                      | 'id'
                      | 'latestPeriodEndDate'
                      | 'latestPeriodStartDate'
                      | 'productName'
                      | 'productId'
                    >
                  >
                >
              >;
            }
        >;
      }
  >;
};

/**
 * @deprecated
 */
export type FetchTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

/**
 * @deprecated
 */
export type FetchTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<
    TransactionAccount,
    'id' | 'transactionAccountNumber' | 'billToPartyPricingEligibilty' | 'displayName' | 'isPartner' | 'status'
  > & {
      billToParty?: Maybe<
        { __typename?: 'CommerceAddress' } & Pick<
          CommerceAddress,
          'name' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postcode' | 'taxId' | 'taxExempt'
        >
      >;
      billingAdmins?: Maybe<
        { __typename?: 'BillingAdminConnection' } & Pick<BillingAdminConnection, 'totalCount'> & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            nodes?: Maybe<
              Array<
                Maybe<{ __typename?: 'BillingAdmin' } & Pick<BillingAdmin, 'email' | 'atlassianAccountId' | 'fullName'>>
              >
            >;
          }
      >;
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
                    shipToParty?: Maybe<
                      { __typename?: 'CommerceAddress' } & Pick<
                        CommerceAddress,
                        | 'id'
                        | 'name'
                        | 'addressLine1'
                        | 'addressLine2'
                        | 'city'
                        | 'state'
                        | 'country'
                        | 'postcode'
                        | 'taxId'
                      >
                    >;
                  }
              >
            >;
          }
      >;
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & PaymentMethodData_CreditCard_Fragment)
                  | ({ __typename?: 'PaymentOnTerms' } & PaymentMethodData_PaymentOnTerms_Fragment)
                >
              >
            >;
          }
      >;
    };
};

type PaymentMethodData_CreditCard_Fragment = { __typename?: 'CreditCard' } & Pick<
  CreditCard,
  'id' | 'type' | 'default'
> & {
    card?: Maybe<
      { __typename?: 'CreditCardDetails' } & Pick<
        CreditCardDetails,
        'expirationMonth' | 'expirationYear' | 'last4Numbers' | 'brand'
      >
    >;
  };

type PaymentMethodData_PaymentOnTerms_Fragment = { __typename?: 'PaymentOnTerms' } & Pick<
  PaymentOnTerms,
  'id' | 'type' | 'default'
> & { terms?: Maybe<{ __typename?: 'PaymentOnTermsDetails' } & Pick<PaymentOnTermsDetails, 'invoiceDueDays'>> };

/**
 * @deprecated
 */
export type PaymentMethodDataFragment =
  | PaymentMethodData_CreditCard_Fragment
  | PaymentMethodData_PaymentOnTerms_Fragment;

/**
 * @deprecated
 */
export type FetchOrgProductsQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchOrgProductsQuery = { __typename?: 'Query' } & {
  organization?: Maybe<
    { __typename?: 'Organization' } & Pick<Organization, 'id'> & {
        products: { __typename?: 'CloudProductConnection' } & Pick<CloudProductConnection, 'totalCount'> & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            edges?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'CloudProductEdge' } & {
                    node?: Maybe<
                      { __typename?: 'CloudProduct' } & Pick<
                        CloudProduct,
                        'id' | 'cloudSiteUrl' | 'productName' | 'isCloud' | 'platform' | 'cloudSiteId' | 'productId'
                      >
                    >;
                  }
                >
              >
            >;
          };
      }
  >;
};

/**
 * @deprecated
 */
export type FetchProductsForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

/**
 * @deprecated
 */
export type FetchProductsForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      products?: Maybe<
        { __typename?: 'TransactionAccountProductConnection' } & Pick<
          TransactionAccountProductConnection,
          'totalCount'
        > & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TransactionAccountProduct' } & Pick<
                    TransactionAccountProduct,
                    | 'billingFrequency'
                    | 'billingStatus'
                    | 'entitlementNumber'
                    | 'transactionAccountNumber'
                    | 'latestPeriodEndDate'
                    | 'latestPeriodStartDate'
                    | 'productName'
                    | 'productId'
                  >
                >
              >
            >;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchBillingAdminsForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchBillingAdminsForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      billingAdmins?: Maybe<
        { __typename?: 'BillingAdminConnection' } & Pick<BillingAdminConnection, 'totalCount'> & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>;
            edges?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'BillingAdminEdge' } & {
                    node: { __typename?: 'BillingAdmin' } & Pick<
                      BillingAdmin,
                      'email' | 'atlassianAccountId' | 'fullName'
                    >;
                  }
                >
              >
            >;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchInvoiceGroupsForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

/**
 * @deprecated
 */
export type FetchInvoiceGroupsForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & Pick<InvoiceGroupConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id' | 'name' | 'currency'> & {
                    purchaseOrder?: Maybe<
                      { __typename?: 'InvoiceGroupPurchaseOrder' } & Pick<
                        InvoiceGroupPurchaseOrder,
                        'number' | 'oneTimeUse'
                      >
                    >;
                    shipToParty?: Maybe<{ __typename?: 'CommerceAddress' } & ShipToPartyDataFragment>;
                    defaultPaymentMethod?: Maybe<
                      | ({ __typename?: 'CreditCard' } & PaymentMethodData_CreditCard_Fragment)
                      | ({ __typename?: 'PaymentOnTerms' } & PaymentMethodData_PaymentOnTerms_Fragment)
                    >;
                  }
              >
            >;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchInvoicesForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchInvoicesForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      invoices?: Maybe<
        { __typename?: 'InvoiceConnection' } & Pick<InvoiceConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'Invoice' } & Pick<
                    Invoice,
                    | 'id'
                    | 'invoiceNumber'
                    | 'purchaseOrderNumber'
                    | 'sourceSystem'
                    | 'paymentMethod'
                    | 'creditCardMaskedNumber'
                    | 'dueDate'
                    | 'createdDate'
                    | 'grandTotal'
                    | 'paymentCurrency'
                  > & {
                      refunds?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'Refunds' } & Pick<
                              Refunds,
                              'id' | 'type' | 'creditNoteNumber' | 'sourceSystem' | 'total' | 'currency' | 'status'
                            >
                          >
                        >
                      >;
                    }
                >
              >
            >;
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>>;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchPaymentMethodsForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

/**
 * @deprecated
 */
export type FetchPaymentMethodsForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      availableInvoiceGroups?: Maybe<
        { __typename?: 'InvoiceGroupConnection' } & {
          nodes: Array<
            Maybe<
              { __typename?: 'InvoiceGroup' } & Pick<InvoiceGroup, 'id'> & {
                  defaultPaymentMethod?: Maybe<
                    | ({ __typename?: 'CreditCard' } & Pick<CreditCard, 'id' | 'type'>)
                    | ({ __typename?: 'PaymentOnTerms' } & Pick<PaymentOnTerms, 'id' | 'type'>)
                  >;
                }
            >
          >;
        }
      >;
      availablePaymentMethods?: Maybe<
        { __typename?: 'PaymentMethodConnection' } & Pick<PaymentMethodConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  | ({ __typename?: 'CreditCard' } & PaymentMethodData_CreditCard_Fragment)
                  | ({ __typename?: 'PaymentOnTerms' } & PaymentMethodData_PaymentOnTerms_Fragment)
                >
              >
            >;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchShipToPartiesForTransactionAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

/**
 * @deprecated
 */
export type FetchShipToPartiesForTransactionAccountQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      availableShipToParties?: Maybe<
        { __typename?: 'CommerceAddressConnection' } & Pick<CommerceAddressConnection, 'totalCount'> & {
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'CommerceAddress' } & Pick<CommerceAddress, 'shipToPriceEligibility'> &
                    ShipToPartyDataFragment
                >
              >
            >;
          }
      >;
    };
};

/**
 * @deprecated
 */
export type FetchTransactionAccountSearchByEmailQueryVariables = Exact<{
  email?: Maybe<Scalars['String']>;
  searchOptions?: Maybe<ConnectionSearchOptions>;
}>;

/**
 * @deprecated
 */
export type FetchTransactionAccountSearchByEmailQuery = { __typename?: 'Query' } & {
  personByEmailAddress?: Maybe<
    { __typename?: 'Person' } & Pick<Person, 'emailAddress'> & {
        transactionAccounts: { __typename?: 'TransactionAccountConnection' } & Pick<
          TransactionAccountConnection,
          'totalCount'
        > & {
            pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>;
            nodes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'TransactionAccount' } & Pick<
                    TransactionAccount,
                    'displayName' | 'id' | 'transactionAccountNumber'
                  >
                >
              >
            >;
          };
      }
  >;
};

/**
 * @deprecated
 */
export type ShipToPartyDataFragment = { __typename?: 'CommerceAddress' } & Pick<
  CommerceAddress,
  'name' | 'id' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postcode' | 'taxId'
>;
